import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { ChartTypesWrapper } from './ChartTypesWrapper';
import * as Utils from '../../../../_common/application/ts/Utilities';
import * as Utilities from '../../../../_common/platform/ts/Utilities';
import { MappingUtilities } from '../../../../_common/platform/ts/MappingUtilities';
import { COLOR_MAP_UNDEF_COLOR, COLOR_MAP_UNDEF_KEY } from '../../../../_common/platform/ts/ConfigurationConstants';
import { IChartOptions, IOnIncidentOccurredParam, IWParams } from './Interfaces';
import { themeFields } from '../themes/themeFields';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import TooltipWrapper from './TooltipWrapper';
import { chartConstants } from '../chartConstants';
import { ChartAxisWrapper } from './ChartAxisWrapper';
import { StripsWrapper } from './StripsWrapper';
import { ChartPropsManager } from '../ChartPropsManager';

import {
    C2F_Multi,
    ChartFunctionsWrapper,
    ConstantLinesWrapper,
    DevExprPaletteManager,
    FontWrapper,
    LabelsFormatWrapper,
    NotificationCallWrapper,
    SeriesXY_PointLabel_Wrapper
} from '../DashboardWidget_dxChart_Parametrized';

class LegendWrapper {
    private static getUnderlyingTypeAndValue(ser) {
        let aTag = ser.tag;
        let argCount = aTag.counters.argCount;

        if (argCount > 1) {
            // if == 1, always strings (= labels)
            let dataType = aTag.x23_dataType; // it may be X2 or X3
            if (argCount === 2) {
                return { dataType: dataType, value: aTag.groupOnly };
            }
            if (argCount === 3) {
                return { dataType: dataType, value: aTag.group }; // also aTag.stack
            }
        }
        return null;
    }

    //LL:  's', 'b'  not interesting
    private static similarTypes(typeA, typeB) {
        if (typeA == 'i' || typeA == 'r') {
            return typeB == 'i' || typeB == 'r';
        }
        if (typeA == 'date' || typeA == 'datetime') {
            return typeB == 'date' || typeB == 'datetime';
        }
        if (typeA == 'time') {
            return typeB == 'time';
        }
        return false;
    }

    private static sortUpDown(items) {
        //   items - Legend items before customizations.
        let res = items.slice(0);
        return res.reverse();
    }

    //LL: for DevExpr ver 19.1:
    //   for strings - alphabetically
    private static sortAscending(items) {
        return items.sort(function (a, b) {
            //  a:  series->tag, text, visible   BaseChartLegendItem -> marker.fill = color
            let itemA: any = a.text.toLowerCase();
            let itemB: any = b.text.toLowerCase();

            //LL: sort by underlying value if x2-x3 exists, number or date
            //    They can be of different series, so of different types !!
            let objA = LegendWrapper.getUnderlyingTypeAndValue(a.series);
            let objB = LegendWrapper.getUnderlyingTypeAndValue(b.series);

            if (objA != null && objB != null) {
                let typeA = objA.dataType;
                let typeB = objB.dataType;
                if (LegendWrapper.similarTypes(typeA, typeB)) {
                    itemA = objA.value;
                    itemB = objB.value;
                }
            }

            if (itemA < itemB) {
                return -1;
            }
            if (itemA > itemB) {
                return 1;
            }
            return 0;
        });
    }

    //LL: for DevExpr ver 19.1:
    //   for strings - anti-alphabetically
    private static sortDescending(items) {
        return items.sort(function (a, b) {
            let itemA: any = a.text.toLowerCase();
            let itemB: any = b.text.toLowerCase();

            //LL: sort by underlying value if x2-x3 exists, number or date
            //    They can be of different series, so of different types !!
            let objA = LegendWrapper.getUnderlyingTypeAndValue(a.series);
            let objB = LegendWrapper.getUnderlyingTypeAndValue(b.series);

            if (objA != null && objB != null) {
                let typeA = objA.dataType;
                let typeB = objB.dataType;

                if (LegendWrapper.similarTypes(typeA, typeB)) {
                    itemA = objA.value;
                    itemB = objB.value;
                }
            }

            if (itemA < itemB) {
                return 1;
            }
            if (itemA > itemB) {
                return -1;
            }
            return 0;
        });
    }

    private static isValidDate(value) {
        var dateWrapper = new Date(value);
        return !isNaN(dateWrapper.getDate());
    }

    private static calcArgumentType_forLegendSort(items) {
        //LL:  Pie can be only 1 DataQuery, so presume that all "argument" type are the same
        let argType = 's';
        if (items.length > 0) {
            if (typeof items[0].argument === 'number') {
                argType = 'n';
            }
            //LL: when UserDefined Intervals for Dates, they are strings, but may be like "2", that isValidDate below
            else if (typeof items[0].argument === 'string') {
                argType = 's';
            }
            //  date ?  time ?   LL: time as a string,  date also ? no
            //  time:   argument: "01:02:03.0000000", so can use as "s"
            else if (LegendWrapper.isValidDate(items[0].argument)) {
                argType = 'd';
            }
        }
        return argType;
    }

    private static getValueToCompare_forLegendSort(item: any, argType) {
        let value;
        if (argType === 'n') {
            value = item.argument;
        } else if (argType === 'd') {
            if (item.argument != null) {
                value = item.argument.toISOString(); // yyyy-MM-DDTHH:mm:ss.sssZ.
            } else {
                value = '';
            }
        } else {
            // if (argType == 's') {   // and "time" here
            //value = item.argument.toLowerCase();
            if (item.argument != null) {
                value = item.argument.toLowerCase();
            } else {
                value = '';
            }
        }
        return value;
    }

    //LL: for DevExpr ver 19.1:  Pie
    //   for strings - alphabetically
    private static sortAscendingPie(items) {
        //LL:  Pie can be only 1 DataQuery, so presume that all "argument" type are the same
        let argType = LegendWrapper.calcArgumentType_forLegendSort(items);

        return items.sort(function (a, b) {
            //  a:  { argument, argumentIndex, points, text, visible }  PieChartLegendItem
            //     argument  The argument of the point(s) that the legend item represents.
            //          Type: String | Date | Number
            //     points:     Type: Array<Point>
            //     text:   Type: any

            //LL:  a.text not always 'string'  !!!

            let itemA: any, itemB: any;
            itemA = LegendWrapper.getValueToCompare_forLegendSort(a, argType);
            itemB = LegendWrapper.getValueToCompare_forLegendSort(b, argType);

            if (itemA < itemB) {
                return -1;
            }
            if (itemA > itemB) {
                return 1;
            }
            return 0;
        });
    }

    //LL: for DevExpr ver 19.1:  Pie
    //   for strings - anti-alphabetically
    private static sortDescendingPie(items) {
        //LL:  Pie can be only 1 DataQuery, so presume that all "argument" type are the same
        let argType = LegendWrapper.calcArgumentType_forLegendSort(items);

        return items.sort(function (a, b) {
            //  a: { argument, argumentIndex, points, text, visible }  PieChartLegendItem
            //     argument  The argument of the point(s) that the legend item represents.
            //          Type: String | Date | Number
            //     points:     Type: Array<Point>
            //     text:   Type: any

            //LL:  a.text not always 'string'  !!!

            let itemA: any, itemB: any;
            itemA = LegendWrapper.getValueToCompare_forLegendSort(a, argType);
            itemB = LegendWrapper.getValueToCompare_forLegendSort(b, argType);

            if (itemA < itemB) {
                return 1;
            }
            if (itemA > itemB) {
                return -1;
            }
            return 0;
        });
    }

    public static createLegend(wParams, isXY, _theme) {
        // legend:  - usually table on the right
        let legendUse = wParams.legend.use;
        //LL: for Pie always legendUse (and see above that either Pie or XY, never both)
        if (!isXY) {
            legendUse = true;
        }
        if (wParams.legend.show) {
            legendUse = true;
        }

        let legend: any = { visible: false };

        //LL: 30.06.20: Note: about Margin, Padding and backgroundColor: ==================
        //  I have created DevExpress ticket:
        //     https://supportcenter.devexpress.com/ticket/details/t903880/dxchart-problem-with-legend-background-color
        //  subj:  dxChart: problem with Legend background color
        //  -------------------
        //  LL:
        //    In the attached sample there are 2 similar Charts.
        //    The left one has legend.backgroundColor, the right one has not.
        //    See that Legends are drawn differently: the left Legend has space around legend item, the right has not.
        //    Legend properties paddingLeftRight and paddingTopBottom are not set.
        //  DevExpress:
        //    This is expected behavior.
        //    paddingLeftRight and paddingTopBottom are applied when backgroundColor or border is defined.  <=====  !!!
        //    Their default value is 10. I suggest you modify them according to your requirement.
        //  ------------------------
        //  LL:
        //    I suspected that it is expected behavior, but to my mind it is wrong.
        //    It is strange and unexpected that when I set legend.backgroundColor, the whole layout of Chart is changed, i.e. the Legend occupies more space and actual Chart becomes smaller.
        //    So, please, be so kind as to reconsider this decision.
        //    And anyway, it should be described in ApiReference.
        //  --------------------------------

        //LL: my decision:
        //   1) Layout must be the same, whether backgroundColor is set or not
        //   2) No sense to use paddingLeftRight and paddingTopBottom, because they are applied only
        //      when backgroundcccColor is set.
        //      So, set them to 0
        //   3) "margin" seems to be applied anyway. So set it to some value  ~~ 8
        //=====================================================================
        const marginDef = 8;

        //LL: in DevExpress there is "orientation" = vert/horiz. And my legend.position is actually legend.orientation
        //    and DevExpress "position" is inside/outside of Chart Window
        let legendOrientation = wParams.legend.position;

        if (legendUse) {
            if (wParams.legend.show) {
                if (legendOrientation == 'horiz') {
                    legend = {
                        orientation: 'horizontal',
                        position: wParams.legend.legendPositionInsideOutside,
                        margin: marginDef,
                        paddingLeftRight: 0, //LL: see Note above. def 10. Specifies a blank space between a legend's left/right boundaries and the inner item boundaries in pixels.
                        paddingTopBottom: 0, //LL: see Note above. def 10. Specifies a blank space between a legend's top/bottom boundaries and the inner item boundaries in pixels
                        //rowCount: 3, //4,
                        columnCount: wParams.legend.columnCountHoriz, // 5,  // 3-min   6-max
                        // rowItemSpacing
                        columnItemSpacing: 3, // def 8
                        itemTextPosition: 'right', // 'right'|'bottom'   default - undef  LL: when Legent is vertical -> 'right', when Legent is horiz -> 'bottom'
                        horizontalAlignment: 'center', // 'right' (def) |'center'|'left'
                        verticalAlignment: wParams.legend.position2
                    };
                } else {
                    // "vert"
                    legend = {
                        //LL: try for DevExpr ver 19.1:  OK
                        //   The following code shows how to use the customizeItems function to sort legend items alphabetically:
                        //customizeItems: function(items) {
                        //    return items.sort(function(a, b) {
                        //        let itemA = a.text.toLowerCase();
                        //        let itemB = b.text.toLowerCase();
                        //        if(itemA < itemB) return -1;
                        //        if(itemA > itemB) return 1;
                        //        return 0;
                        //    });
                        //},
                        orientation: 'vertical',
                        position: wParams.legend.legendPositionInsideOutside,
                        margin: marginDef,
                        paddingLeftRight: 0, //LL: see Note above. def 10. Specifies a blank space between a legend's left/right boundaries and the inner item boundaries in pixels.
                        paddingTopBottom: 0, //LL: see Note above. def 10. Specifies a blank space between a legend's top/bottom boundaries and the inner item boundaries in pixels
                        columnCount: wParams.legend.columnCountVert, // 1,   // 1 - 2
                        verticalAlignment: 'top',
                        horizontalAlignment: wParams.legend.position2
                    };
                }

                legend.visible = true;

                let legendFont: any;
                let fo = FontWrapper.createFontObj_fromTheme(wParams, _theme, themeFields.font_inLegend);
                if (fo != null) {
                    let foKeys = _.keys(fo);
                    if (foKeys.length > 0) {
                        legendFont = fo;
                    }
                }
                if (wParams.legend.fontColor != null) {
                    if (legendFont == null) {
                        legendFont = {};
                    }
                    legendFont.color = wParams.legend.fontColor;
                }
                if (legendFont != null) {
                    legend.font = legendFont;
                }

                if (wParams.legend.bgColor != null) {
                    legend.backgroundColor = wParams.legend.bgColor;
                }

                //LL: for DevExpr ver 19.1:
                if (isXY) {
                    // Pie has another params in Sort
                    if (wParams.legend.itemSorting == 'ascending') {
                        legend.customizeItems = LegendWrapper.sortAscending;
                    } else if (wParams.legend.itemSorting == 'descending') {
                        legend.customizeItems = LegendWrapper.sortDescending;
                    }
                    //LL: UpDown Sorting (Opposite Order)
                    else if (wParams.legend.itemSorting == 'oppositeOrder') {
                        legend.customizeItems = LegendWrapper.sortUpDown;
                    }
                } else {
                    // Pie
                    if (wParams.legend.itemSorting == 'ascending') {
                        legend.customizeItems = LegendWrapper.sortAscendingPie;
                    } else if (wParams.legend.itemSorting == 'descending') {
                        legend.customizeItems = LegendWrapper.sortDescendingPie;
                    }
                    //LL: UpDown Sorting (Opposite Order)
                    else if (wParams.legend.itemSorting == 'oppositeOrder') {
                        legend.customizeItems = LegendWrapper.sortUpDown;
                    }
                }
            }
        }
        return legend;
    }
}

class CustomStylesWrapper {
    public static updateSeriesByCustomStyles(wParams, series) {
        let customStyles = [];
        if (wParams.customStyles.useCustomStyles === true) {
            for (let i = 0; i < wParams.customStyles.customStyles.length; i++) {
                let csDef = wParams.customStyles.customStyles[i];
                customStyles.push($.extend(true, {}, csDef));
            }
        }

        if (customStyles.length > 0) {
            for (let k = 0; k < series.length; k++) {
                let ser = series[k];
                if (ser.customStyle != null) {
                    let cs = ser.customStyle;
                    for (let i = 0; i < customStyles.length; i++) {
                        if (cs === customStyles[i].name) {
                            delete ser.customStyle;

                            //  - color
                            let color;
                            if (customStyles[i].colorDefault === true) {
                                //LL: leave color as null
                            } else if (customStyles[i].colorPalette === true) {
                                let palette = wParams.palette;

                                //LL:  DevExpress 18.1.5:
                                //    The ""palette"" option does not accept the "Default" value since v.18.1. Use the "Office" value instead
                                //    Added:  'Material', 'Office'    Default Value: 'Material'
                                if (palette == null) {
                                    palette = 'Office';
                                }

                                let simpleSetColors = DevExprPaletteManager.getPaletteColors(palette);
                                if (simpleSetColors != null && simpleSetColors.length > 0) {
                                    let ind = customStyles[i].indexInPalette - 1;
                                    if (ind >= simpleSetColors.length) {
                                        ind = ind % simpleSetColors.length;
                                    }
                                    color = simpleSetColors[ind];
                                }
                            } else {
                                if (customStyles[i].color != null) {
                                    color = customStyles[i].color;
                                }
                            }
                            if (color != null) {
                                ser.color = color;
                            }

                            // -- opacity, dashStyle, width

                            if (customStyles[i].opacity != null) {
                                ser.opacity = customStyles[i].opacity;
                            }
                            if (customStyles[i].dashStyle != null) {
                                ser.dashStyle = customStyles[i].dashStyle;
                            }
                            if (customStyles[i].width != null) {
                                ser.width = customStyles[i].width;
                            }

                            // -- ser.point:  point.size, point.symbol, point.color

                            if (ser.point == null) {
                                ser.point = {};
                            }

                            //LL: for area, splinearea, steparea:
                            //    is set in chartOptions.commonSeriesSettings, but seems must be repeated here
                            let serType = ser.type;
                            if (
                                serType === 'area' ||
                                serType === 'stackedarea' ||
                                serType === 'fullstackedarea' ||
                                serType === 'splinearea' ||
                                serType === 'stackedsplinearea' ||
                                serType === 'fullstackedsplinearea' ||
                                serType === 'steparea' ||
                                serType === 'stackedsteparea' ||
                                serType === 'fullstackedsteparea' ||
                                serType === 'rangearea'
                            ) {
                                let pointVis = wParams.showPointsInArea == null ? false : wParams.showPointsInArea;
                                ser.point.visible = pointVis;
                            }

                            if (customStyles[i].pointSize != null) {
                                ser.point.size = customStyles[i].pointSize;
                            }
                            if (customStyles[i].pointSymbol != null) {
                                ser.point.symbol = customStyles[i].pointSymbol;
                            }
                            let pointColor;
                            if (customStyles[i].pointColorDefault === true) {
                                //LL: leave pointColor as null
                            } else {
                                if (customStyles[i].pointColor != null) {
                                    pointColor = customStyles[i].pointColor;
                                }
                            }
                            if (pointColor != null) {
                                ser.point.color = pointColor;
                            }

                            // -- ser.label:  Angle,  position,  back, text, border colors, offsets ?

                            if (ser.label == null) {
                                ser.label = {};
                            }

                            // Position
                            let labelPosition;
                            if (customStyles[i].labelPositionDefault !== false) {
                                //LL: leave as null
                            } else {
                                if (customStyles[i].labelPosition != null) {
                                    labelPosition = customStyles[i].labelPosition;
                                } else {
                                    labelPosition = chartConstants.defaultPointLabelPosition;
                                }
                            }
                            if (labelPosition != null) {
                                ser.label.position = labelPosition;
                            }

                            // Rotation Angle
                            let labelRotationAngle;
                            if (customStyles[i].labelRotationAngleDefault !== false) {
                                //LL: leave as null
                            } else {
                                if (customStyles[i].labelRotationAngle != null) {
                                    labelRotationAngle = customStyles[i].labelRotationAngle;
                                } else {
                                    labelRotationAngle = chartConstants.defaultPointLabelRotationAngle;
                                }
                            }
                            if (labelRotationAngle != null) {
                                ser.label.rotationAngle = labelRotationAngle;
                            }

                            // Label Colors
                            let labelColorBack, labelColorText, labelColorBorder;
                            if (customStyles[i].labelColorsDefault !== false) {
                                //LL: leave as null
                            } else {
                                if (customStyles[i].labelColorBack != null) {
                                    labelColorBack = customStyles[i].labelColorBack;
                                } else {
                                    labelColorBack = chartConstants.defaultPointLabelColorBack;
                                }
                                if (customStyles[i].labelColorText != null) {
                                    labelColorText = customStyles[i].labelColorText;
                                } else {
                                    labelColorText = chartConstants.defaultPointLabelColorText;
                                }
                                if (customStyles[i].labelColorBorder != null) {
                                    labelColorBorder = customStyles[i].labelColorBorder;
                                } else {
                                    labelColorBorder = chartConstants.defaultPointLabelColorBorder;
                                }
                            }
                            if (labelColorBack != null) {
                                ser.label.backgroundColor = labelColorBack;
                            }
                            if (labelColorText != null) {
                                if (ser.label.font == null) {
                                    ser.label.font = {};
                                }
                                ser.label.font.color = labelColorText;
                            }
                            if (labelColorBorder != null) {
                                if (ser.label.border == null) {
                                    ser.label.border = {};
                                }
                                ser.label.border.color = labelColorBorder;
                                ser.label.border.visible = true;
                            }
                        }
                    }
                }
            }
        }
    }
}

class BreaksWrapper {
    private wParams: any = {};

    constructor(_wParams) {
        this.wParams = _wParams;
    }

    public createBreaks(argType, yType) {
        let breaksX = [];
        let breaksY = [];

        if (this.wParams.axisBreaks != null && this.wParams.axisBreaks.breaks != null) {
            for (let i = 0; i < this.wParams.axisBreaks.breaks.length; i++) {
                let breakDef = this.wParams.axisBreaks.breaks[i];
                let brk: any = {
                    startValue: breakDef.startValue,
                    endValue: breakDef.endValue
                };

                //LL: only for "time", "date"/"datetime" was OK already (see in ConstLines)
                if (breakDef.type === 'values' && DateTimeFunctions.isTypeOfTime(yType)) {
                    // isTypeOfAnyDate
                    let sDate = StripsWrapper.convertToDateTime(yType, brk.startValue);

                    if (sDate != null) {
                        brk.startValue = sDate;
                    }

                    let eDate = StripsWrapper.convertToDateTime(yType, brk.endValue);

                    if (eDate != null) {
                        brk.endValue = eDate;
                    }
                }
                if (breakDef.type === 'arguments' && DateTimeFunctions.isTypeOfTime(argType)) {
                    // isTypeOfAnyDate
                    let sDate = StripsWrapper.convertToDateTime(argType, brk.startValue);
                    if (sDate != null) {
                        brk.startValue = sDate;
                    }
                    let eDate = StripsWrapper.convertToDateTime(argType, brk.endValue);
                    if (eDate != null) {
                        brk.endValue = eDate;
                    }
                }

                if (breakDef.type === 'values') {
                    breaksY.push(brk);
                } else if (breakDef.type === 'arguments') {
                    breaksX.push(brk);
                } else {
                    //LL:  no for Aux
                }
            }
        }

        let breaksObj = {
            breaksX: breaksX, // [];
            breaksY: breaksY // [];
        };

        return breaksObj;
    }
}

class CrosshairWrapper {
    public static createCrosshair_forXY(wParams, chartWidgetObj, _theme) {
        let crosshair: any = {
            enabled: true
            //color: "#949494",
            ////width: 3,
            ////dashStyle:"dot",
            //width: 2,
            //dashStyle:"solid",
            //label: {
            //    visible: true,
            //    backgroundColor: "#949494",
            //    font: {
            //        color: "#fff",
            //        size: 12
            //    }
            //}
        };

        //LL: note: all props can be defined individually for Vert and Horiz lines.

        //LL: in DevExpr default for visible is True
        //  Horiz/Vert, not Y/X - because of "rotated"

        if (wParams.crosshair != null && wParams.crosshair.visible_Vert !== true) {
            crosshair.verticalLine = { visible: false };
        }
        if (wParams.crosshair != null && wParams.crosshair.visible_Horiz !== true) {
            crosshair.horizontalLine = { visible: false };
        }

        // opacity is inside Color
        if (wParams.crosshair != null && wParams.crosshair.lineColor != null) {
            crosshair.color = wParams.crosshair.lineColor;
        }
        if (wParams.crosshair != null && wParams.crosshair.lineWidth != null) {
            crosshair.width = wParams.crosshair.lineWidth;
        }
        if (wParams.crosshair != null && wParams.crosshair.dashStyle != null) {
            crosshair.dashStyle = wParams.crosshair.dashStyle;
        }

        // Labels:  visibility - default=False
        if (wParams.crosshair != null && wParams.crosshair.labels_visible_Vert === true) {
            if (crosshair.verticalLine == null) {
                crosshair.verticalLine = {};
            }
            crosshair.verticalLine.label = { visible: true };
        }
        if (wParams.crosshair != null && wParams.crosshair.labels_visible_Horiz === true) {
            if (crosshair.horizontalLine == null) {
                crosshair.horizontalLine = {};
            }
            crosshair.horizontalLine.label = { visible: true };
        }

        //LL: labels colors for both
        if (wParams.crosshair != null && wParams.crosshair.labels_back_color != null) {
            if (crosshair.label == null) {
                crosshair.label = {};
            }
            crosshair.label.backgroundColor = wParams.crosshair.labels_back_color;
        }
        if (wParams.crosshair != null && wParams.crosshair.labels_font_color != null) {
            if (crosshair.label == null) {
                crosshair.label = {};
            }
            if (crosshair.label.font == null) {
                crosshair.label.font = {};
            }
            crosshair.label.font.color = wParams.crosshair.labels_font_color;
        }

        return crosshair;
    }
}

class PiePointLabel_Wrapper {
    private wParams: any = {};
    private seriesTag: any;
    private ArgumentAndPointLabels: any;
    private addSeriesNameToLabel = false;
    private dataTypes: any;
    private aTheme: any;
    private argLabelOverride = false; // "XL", used for Labels, legend, tooltip
    private pointLabelOverride = false; // "XP", used for Labels

    constructor(_wParams, _seriesTag, _ArgumentAndPointLabels, _addSeriesNameToLabel, _dataTypes, _theme) {
        this.wParams = _wParams;
        this.seriesTag = _seriesTag;
        this.ArgumentAndPointLabels = _ArgumentAndPointLabels;
        this.addSeriesNameToLabel = _addSeriesNameToLabel;
        this.dataTypes = _dataTypes;
        this.aTheme = _theme;

        if (this.seriesTag != null) {
            let counts = this.seriesTag.counters;
            if (counts != null && (counts.xlCount > 0 || counts.xlCount_group > 0)) {
                this.argLabelOverride = true;
            }
        }

        if (this.seriesTag != null) {
            let counts = this.seriesTag.counters;
            if (counts != null && (counts.xpCount > 0 || counts.xpCount_group > 0)) {
                this.pointLabelOverride = true;
            }
        }

        this.getPointLabel = this.getPointLabel.bind(this);
        this.getArgumentLabel = this.getArgumentLabel.bind(this);
        this.legend_customizeText = this.legend_customizeText.bind(this);
        this.legend_customizeText_Override = this.legend_customizeText_Override.bind(this);
    }

    public get_argLabelOverride() {
        return this.argLabelOverride;
    }

    public get_pointLabelOverride() {
        return this.pointLabelOverride;
    }

    public getPointLabel(arg) {
        //LL: in constructor - this.getPointLabel = this.getPointLabel.bind(this);
        if (this.ArgumentAndPointLabels != null) {
            if (this.ArgumentAndPointLabels[arg] != null) {
                let pl = this.ArgumentAndPointLabels[arg].pointLabel;
                if (pl != null && pl.toString() !== '') {
                    pl = LabelsFormatWrapper.getFormatted(
                        pl,
                        null,
                        this.seriesTag,
                        'xP_formats',
                        this.wParams.currency,
                        'Labels',
                        'pointLabel'
                    );
                    return pl;
                }
            }
        }
        return null;
    }

    public getArgumentLabel(arg) {
        if (this.ArgumentAndPointLabels != null) {
            if (this.ArgumentAndPointLabels[arg] != null) {
                let pl = this.ArgumentAndPointLabels[arg].label;
                if (pl != null && pl.toString() !== '') {
                    pl = LabelsFormatWrapper.getFormatted(
                        pl,
                        null,
                        this.seriesTag,
                        'xL_formats',
                        this.wParams.currency,
                        'argLabel'
                    );
                    return pl;
                }
            }
        }
        return arg;
    }

    // - Legend

    public legend_customizeText_Override(pointInfo) {
        return this.getArgumentLabel(pointInfo.pointName);
    }

    public legend_customizeText(pointInfo) {
        let pp: any = pointInfo.pointName;
        pp = LabelsFormatWrapper.getFormatted(
            pp,
            pp.toString(),
            this.seriesTag,
            'x_formats',
            this.wParams.currency,
            'Legend'
        );

        //LL: error when name is "<NOT SET>":     change "<" by &lt
        pp = pp.replace(/</gi, '&lt').replace(/>/gi, '&gt');

        return pp;
    }

    // - Tooltip

    private getTooltipForTooltip(_pointInfo) {
        let _seriesTag = _pointInfo.point.series.tag;

        let sA = '';
        if (_seriesTag == null || _seriesTag.T_ref == null) {
            return sA;
        }

        let tooltipValue = _pointInfo.point.data.T;
        let tooltipText = LabelsFormatWrapper.getFormatted(
            tooltipValue,
            null,
            _seriesTag,
            'T_formats',
            this.wParams.currency,
            'Tooltip',
            this.wParams
        );

        sA += tooltipText;
        return sA;
    }

    private getTooltipForPointColor(_pointInfo) {
        let labelText;
        let _seriesTag = _pointInfo.point.series.tag;
        if (_seriesTag != null) {
            let xc_showInTooltip = _seriesTag.xc_showInTooltip;
            if (xc_showInTooltip == null) {
                xc_showInTooltip = this.wParams.externalFunctions.ShowInTooltip_Defaults.XC;
            }
            if (xc_showInTooltip != true) {
                return labelText;
            }

            let counts = _seriesTag.counters;
            if (
                counts != null &&
                ((counts.xcCount != null && counts.xcCount > 0) ||
                    (counts.xcCount_group != null && counts.xcCount_group > 0))
            ) {
                //LL: note: also there is counts.xcAttrib   not needed here

                labelText = '';
                if (_seriesTag.xc_label != null) {
                    labelText += _seriesTag.xc_label + ' = ';
                }

                let apl = this.ArgumentAndPointLabels;

                if (apl != null) {
                    if (apl[_pointInfo.argument] != null) {
                        let c = apl[_pointInfo.argument].color;
                        if (c != null) {
                            c = LabelsFormatWrapper.getFormatted(
                                c,
                                null,
                                _seriesTag,
                                'xc_formats',
                                this.wParams.currency,
                                'Tooltip',
                                'pointColor'
                            );
                            labelText += c;
                        }
                    } else {
                        if (
                            _pointInfo.point != null &&
                            _pointInfo.point.data != null &&
                            _pointInfo.point.data.colorValue != null
                        ) {
                            labelText += _pointInfo.point.data.colorValue;
                        }
                    }
                }
            }
        }

        return labelText;
    }

    //LL: for mobile: add tooltipsObj (=wParams.tooltips)
    public createTooltipOption_Pie(showLabelsRes, tooltipsObj, _argTimePart, _yTimePart) {
        let self = this;

        let enabled = true;
        if (tooltipsObj != null && tooltipsObj.hide === true) {
            enabled = false;
        } //LL: for mobile

        let labelTooltip: any = {
            enabled: enabled,
            format: { percentPrecision: 2 },
            customizeTooltip: function (pointInfo) {
                // Return Value: Object - Specifies the text to be displayed in a tooltip and a color for the tooltip.

                let _seriesTag = pointInfo.point.series.tag;

                if (_seriesTag.counters.TCount > 0 || _seriesTag.counters.TCount_group > 0) {
                    let t = self.getTooltipForTooltip(pointInfo);
                    return { text: t };
                }

                let x_showInTooltip = true;
                let y_showInTooltip = true;
                if (_seriesTag != null) {
                    x_showInTooltip = _seriesTag.x_showInTooltip;
                    if (x_showInTooltip == null) {
                        x_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.X1;
                    }
                    y_showInTooltip = _seriesTag.y_showInTooltip;
                    if (y_showInTooltip == null) {
                        y_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.Y;
                    }
                }

                let argText: any;
                if (x_showInTooltip === true) {
                    argText = pointInfo.argumentText;
                    if (self.argLabelOverride) {
                        argText = self.getArgumentLabel(pointInfo.argument);
                    } else {
                        argText = LabelsFormatWrapper.getFormattedArgument(
                            pointInfo,
                            self.wParams,
                            null,
                            _argTimePart,
                            'Tooltip'
                        );
                    }
                    //LL: error when name is "<NOT SET>":     change "<" by &lt
                    argText = argText.replace(/</gi, '&lt').replace(/>/gi, '&gt');
                }

                let valueText: any;
                if (y_showInTooltip === true) {
                    valueText = LabelsFormatWrapper.getFormattedValue(
                        pointInfo,
                        self.wParams,
                        null,
                        _yTimePart,
                        false,
                        'Tooltip'
                    );
                }

                let s = '';

                if (valueText != null) {
                    let labY = 'value';
                    if (_seriesTag != null) {
                        labY = _seriesTag.y;
                    }
                    s = labY + ' = ' + valueText + ' (' + pointInfo.percentText + ')';
                }
                if (argText != null) {
                    let s2 = valueText != null ? ': ' : '';
                    s = argText + s2 + s;
                }

                let seriesName = pointInfo.seriesName;
                if (self.addSeriesNameToLabel && seriesName != null && seriesName !== '') {
                    s = seriesName + '\n' + s;
                }

                let xP_showInTooltip = false;
                if (_seriesTag != null) {
                    xP_showInTooltip = _seriesTag.xP_showInTooltip;
                    if (xP_showInTooltip == null) {
                        xP_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.XP;
                    }
                }
                if (xP_showInTooltip === true) {
                    let xP = pointInfo.point.data.namePoint;
                    xP = LabelsFormatWrapper.getFormatted(
                        xP,
                        null,
                        _seriesTag,
                        'xP_formats',
                        self.wParams.currency,
                        'Tooltip',
                        'pointLabel'
                    );
                    s += '\n' + _seriesTag.xP_label + ' = ' + xP;
                }

                let xL_showInTooltip = false;
                if (_seriesTag != null) {
                    xL_showInTooltip = _seriesTag.xL_showInTooltip;
                    if (xL_showInTooltip == null) {
                        xL_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.XL;
                    }
                }
                if (xL_showInTooltip === true) {
                    let xL = pointInfo.point.data.nameLabel;
                    xL = LabelsFormatWrapper.getFormatted(
                        xL,
                        null,
                        _seriesTag,
                        'xL_formats',
                        self.wParams.currency,
                        'Tooltip',
                        'argLabel'
                    );
                    s += '\n' + _seriesTag.xL_label + ' = ' + xL;
                }

                //   roleC2Fs
                let C2F_showInTooltip = false;
                if (_seriesTag != null) {
                    C2F_showInTooltip = _seriesTag.C2F_showInTooltip;
                    if (C2F_showInTooltip == null) {
                        C2F_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.C2F;
                    }
                }
                if (C2F_showInTooltip === true) {
                    let C2F = pointInfo.point.data.C2F;
                    C2F = LabelsFormatWrapper.getFormatted(
                        C2F,
                        null,
                        _seriesTag,
                        'C2F_formats',
                        self.wParams.currency,
                        'Tooltip'
                    );
                    s += '\n' + _seriesTag.C2F_label + ' = ' + C2F;
                }

                //LL: Attribute  A     here for PIE
                //LL:  they can be many !!!!!!!!!
                if (_seriesTag != null) {
                    let roleAttributes = _seriesTag.roleAttributes;
                    if (roleAttributes != null) {
                        //LL:  order of roleAttributes must be the same as in point.data.A: 1) Groups 2) Attrs
                        let aa = pointInfo.point.data.A;
                        for (let ia: number = 0; ia < roleAttributes.length; ia++) {
                            let ra = roleAttributes[ia];

                            let A_showInTooltip = false;
                            A_showInTooltip = ra.A_showInTooltip;
                            if (A_showInTooltip == null) {
                                A_showInTooltip = self.wParams.externalFunctions.ShowInTooltip_Defaults.A;
                            }

                            if (A_showInTooltip === true) {
                                let A = aa[ia];
                                if (A != null) {
                                    A = LabelsFormatWrapper.getFormatted(
                                        A,
                                        null,
                                        ra,
                                        'A_formats',
                                        self.wParams.currency,
                                        'Tooltip'
                                    );
                                }
                                s += '\n' + ra.A_label + ' = ' + A;
                            }
                        }
                    }
                }

                let colorText = self.getTooltipForPointColor(pointInfo);
                if (colorText != null) {
                    s += '\n' + colorText;
                }

                return { text: s };
            }
        };

        let fo = FontWrapper.createFontObj_fromTheme(this.wParams, this.aTheme, themeFields.font_inTooltip);
        if (fo != null) {
            let foKeys = _.keys(fo);
            if (foKeys.length > 0) {
                if (labelTooltip.font == null) {
                    labelTooltip.font = {};
                }
                _.extend(labelTooltip.font, fo); // shallow
            }
        }

        return labelTooltip;
    }

    // - PointLabel

    public createPointLabelOption_Pie(_argTimePart, _yTimePart) {
        let self = this;
        let labelPie: any = {
            visible: this.wParams.labelPie.showPieLabelsBool,
            //backgroundColor: "Silver",
            //border: { visible: true, color: "Red", width: 1 },
            connector: {
                visible: this.wParams.labelPie.connectorVisible
            },

            customizeText: function (pointInfo) {
                //  pointInfo: value, valueText, argument, argumentText, seriesName
                //  "this" here is pointInfo

                let seriesName = pointInfo.seriesName;

                if (self.pointLabelOverride) {
                    let labelText = self.getPointLabel(pointInfo.argument);
                    if (labelText != null && labelText !== '') {
                        if (self.addSeriesNameToLabel && seriesName != null && seriesName !== '') {
                            labelText = seriesName + ': ' + labelText;
                        }
                        return labelText;
                    }
                }

                let argText = pointInfo.argumentText;
                if (self.argLabelOverride) {
                    argText = self.getArgumentLabel(pointInfo.argument);
                } else {
                    argText = LabelsFormatWrapper.getFormattedArgument(
                        pointInfo,
                        self.wParams,
                        null,
                        _argTimePart,
                        'Labels'
                    );
                }
                //LL: error when name is "<NOT SET>":     change "<" by &lt
                argText = argText.replace(/</gi, '&lt').replace(/>/gi, '&gt');

                let v = pointInfo.valueText;

                let valueTxt = LabelsFormatWrapper.getFormattedValue(
                    pointInfo,
                    self.wParams,
                    null,
                    _yTimePart,
                    false,
                    'Labels'
                );
                v = valueTxt;

                let s = argText + ': ' + v;

                let tag = pointInfo.point.series.tag;

                let tfm = self.wParams.labelPie.textFormat_multi;
                if (tfm != null && tfm.length !== 0) {
                    s = '';
                    for (let i = 0; i < tfm.length; i++) {
                        let s1 = '';
                        switch (tfm[i]) {
                            case 'value':
                                s1 = v;
                                let extendedLabelMode = false;
                                if (
                                    self.aTheme != null &&
                                    self.aTheme[themeFields.pointLabels_showInLabel_pie_addValueDataLabel] != null
                                ) {
                                    extendedLabelMode =
                                        self.aTheme[themeFields.pointLabels_showInLabel_pie_addValueDataLabel];
                                }
                                if (extendedLabelMode) {
                                    let labY = 'value';
                                    if (tag != null) {
                                        labY = tag.y;
                                    }
                                    s1 = labY + ': ' + v;
                                }
                                break;
                            case 'value_percent':
                                s1 = pointInfo.percentText;
                                break;
                            case 'argument':
                                s1 = argText;
                                break;
                        }
                        if (s.length > 0) {
                            s += '; ';
                        }
                        s += s1;
                    }
                }

                if (self.addSeriesNameToLabel && seriesName != null && seriesName !== '') {
                    s = seriesName + ': ' + s;
                }
                return s;
            },
            position: this.wParams.labelPie.position,
            radialOffset: this.wParams.labelPie.radialOffset,
            rotationAngle: this.wParams.labelPie.rotationAngle
        };

        if (this.wParams.labelPie.useDefaultFontColor === false && this.wParams.labelPie.fontColor != null) {
            labelPie.font = { color: this.wParams.labelPie.fontColor };
        }

        if (
            this.wParams.labelPie.useBackgroundColor_default === false &&
            this.wParams.labelPie.backgroundColor != null
        ) {
            labelPie.backgroundColor = this.wParams.labelPie.backgroundColor;
        }
        if (this.wParams.labelPie.borderVisible === true && this.wParams.labelPie.borderColor != null) {
            labelPie.border = {
                visible: true,
                color: this.wParams.labelPie.borderColor
            };
        }

        let fo = FontWrapper.createFontObj_fromTheme(this.wParams, this.aTheme, themeFields.font_inPointLabels);
        if (fo != null) {
            let foKeys = _.keys(fo);
            if (foKeys.length > 0) {
                if (labelPie.font == null) {
                    labelPie.font = {};
                }
                _.extend(labelPie.font, fo); // shallow
            }
        }

        return labelPie;
    }
}

export class ChartOptionsController {
    public static ChartNum2: number = 0;

    private static chartTypesWrapperObj = new ChartTypesWrapper();

    // - based on chartTypesWrapperObj:  (and make it private)

    public static getIsXY(chartType) {
        return ChartOptionsController.chartTypesWrapperObj.getIsXY(chartType);
    }

    public static GetChartTypeDefault() {
        return ChartOptionsController.chartTypesWrapperObj.GetChartTypeDefault();
    }

    public static isContinuousChartType(chartType) {
        return ChartOptionsController.chartTypesWrapperObj.isContinuousChartType(chartType);
    }

    public static isFiscal(chartType) {
        return ChartOptionsController.chartTypesWrapperObj.isFiscal(chartType);
    }

    public static isRange(chartType) {
        return ChartOptionsController.chartTypesWrapperObj.isRange(chartType);
    }

    private static hasPie(geometry) {
        return ChartOptionsController.chartTypesWrapperObj.hasPie(geometry);
    }

    private static hasXY(geometry) {
        return ChartOptionsController.chartTypesWrapperObj.hasXY(geometry);
    }

    //LL: DevExpress 18.1.5:
    //    The ""palette"" option does not accept the "Default" value since v.18.1. Use the "Office" value instead
    //    Added:  'Material', 'Office'    Default Value: 'Material'
    //LL: DevExpr builtin:   Also can be custom
    public static paletteList = [
        //{ id: 1, text: "default" },
        { id: 1, text: 'Office' },
        { id: 2, text: 'Soft Pastel' },
        { id: 3, text: 'Harmony Light' },
        { id: 4, text: 'Pastel' },
        { id: 5, text: 'Bright' },
        { id: 6, text: 'Soft' },
        { id: 7, text: 'Ocean' },
        { id: 8, text: 'Vintage' },
        { id: 9, text: 'Violet' }
    ];

    private static palette1 = ChartOptionsController.paletteList[0]; // [0]: with id=1, i.e. "default"

    public static paletteDefault: string = ChartOptionsController.palette1.text;

    public static singleSeriesColorDefault = '#ba4d51';

    public static stripColorDefault = '#dae0f7';
    public static stripLabelFontColorDefault = 'blue';

    public static constantLinesColorDefault = '#000000';
    public static constantLinesLabelFontColorDefault = '#000000';
    public static constantLinesDashStyleDefault = 'longDash';
    public static constantLinesWidthDefault = 1;

    public static showPieLabelsBool_Default = true;
    public static whiteBlackLabelsThreshold_Default: number = 10;
    public static showPieLabelsThreshold_Default: number = 20;

    public static heightDefault: number = 400;
    public static argumentAngleDefault: number = 30; // clockwise

    public static build_colorMapping_argument(argAttr, dataSourceID) {
        if (argAttr == null || dataSourceID == null) {
            return '';
        }
        return argAttr + '→' + dataSourceID.toString();
    }

    //LL:  used when  useColoringByDataQuery is true
    private static evalColorByMapping(point, seriesTag: any, maxValueC, minValueC, colorMapping) {
        let resColor;

        let counters = seriesTag.counters;

        //LL: fresh idea: mapping may be null, but value is color itself !  (value from DB or expression)
        //    So, the main thing is existence of XC
        let hasXC = counters != null && (counters.xcCount > 0 || counters.xcCount_group > 0);
        if (!hasXC) {
            return null;
        }

        let mapping = seriesTag.mapping; //  Colorscale or DiscreteMapping    + AttributeMapping

        //LL: fresh idea: mapping may be null, but value is color itself !  (value from DB or expression)
        if (mapping == null) {
            let colorValue: any = point.data.colorValue;
            //LL: must be at least a string.  Or number, to convert to hex-string
            if (colorValue != null) {
                //LL: check color format here

                //LL: try wrong color:
                //colorValue = "123";  // OK, no coloring, default is used
                //colorValue = "aartye";   // OK, no coloring, default is used
                //colorValue = 123;  //  bad
                //colorValue = 'rgb(255, 0, 0)';  //  OK
                //colorValue = "green";  // OK

                if (typeof colorValue === 'string') {
                    //LL: check color format here

                    let isValidColor = Utilities.isStringValidColor(colorValue);

                    if (isValidColor) {
                        return colorValue;
                    } else {
                        return null;
                    }
                }
            }
            return null;
        }

        if (mapping != null) {
            //   interface IMappingValue {
            //       mappingType: MappingType;
            //       mappingName: string;
            //       }
            //   type MappingType = 'DiscreteMapping' | 'ColorScale';

            let v = point.value;

            let colorValue: any = point.data.colorValue;
            v = colorValue;

            if (mapping.mappingType === 'ColorScale') {
                let cmfn = seriesTag.colorMappingForNumericObj; //LL: added Date and Time values for Discrete Color Mapping
                if (cmfn != null) {
                    let minV = 0;
                    let maxV = 0;
                    //LL: maxValueC, minValueC - calculated in getDataSource
                    if (minValueC != null) {
                        minV = minValueC;
                    }
                    if (maxValueC != null) {
                        maxV = maxValueC;
                    }

                    //LL: dataType is added: evaluateColor(value, minValue, maxValue, cmfnObj, dataType?)
                    //LL: added Date and Time values for Discrete Color Mapping
                    let vColor = Utilities.ColorHexWrapper.evaluateColor(v, minV, maxV, cmfn);
                    if (vColor != null) {
                        resColor = vColor;
                    }
                }
            }

            if (mapping.mappingType === 'DiscreteMapping') {
                let dm = seriesTag.discreteMappingsObj;
                if (dm != null) {
                    let vColor = MappingUtilities.evaluateDiscreteMapping(v, dm);
                    if (vColor != null) {
                        resColor = vColor;
                    }
                }
            }

            if (mapping.mappingType === 'AttributeMapping') {
                let argAttr = seriesTag.x_color;
                if (colorMapping != null && argAttr != null) {
                    let dataSourceID = counters != null && counters.dataSourceID != null ? counters.dataSourceID : 1;
                    let cmArg = colorMapping[ChartOptionsController.build_colorMapping_argument(argAttr, dataSourceID)];

                    let argColor;
                    if (cmArg != null) {
                        argColor = cmArg[v];
                        if (argColor == null) {
                            argColor = cmArg[COLOR_MAP_UNDEF_KEY];
                        }
                    }

                    if (argColor == null) {
                        argColor = COLOR_MAP_UNDEF_COLOR;
                    }
                    if (argColor != null) {
                        resColor = argColor;
                    }
                }
            }
        }

        return resColor;
    }

    public static validatePolarChart(wParams) {
        let errMsg = [];
        if (wParams.asPolarChart != true) {
            return null; //errMsg;
        }

        let prohibitPolar = false;

        let wrongChartType = false;
        let wrongChartTypes = [];
        let secondaryValueAxis = false;
        let aq = wParams.externalFunctions.attrQueryMulti.attrQueries;
        for (let i = 0; i < aq.length; i++) {
            let chartType = aq[i].parameters.chartType;
            let PolarChartTypes =
                chartType === 'line' ||
                chartType === 'area' ||
                chartType === 'scatter' ||
                chartType === 'bar' ||
                chartType === 'stackedbar';
            if (!PolarChartTypes) {
                wrongChartType = true;
                wrongChartTypes.push(chartType);
            }
            if (aq[i].parameters.secondaryValueAxis != null) {
                secondaryValueAxis = true;
            }
        }

        let useRangeSelector =
            wParams.scrollOrZoom.useScrollOrZoom != null && wParams.scrollOrZoom.useScrollOrZoom != 'none';

        prohibitPolar = wrongChartType;

        //LL: or only message text, all are warnings with action:
        if (wrongChartType) {
            errMsg.push(
                '"Show as PolarChart" is requested, but is possible only for Types: line, area, scatter, bar, stackedbar.<br>' +
                    'Wrong Chart Types are: ' +
                    wrongChartTypes.join(', ') +
                    '.<br>' +
                    'Widget is shown as ordinary Chart'
            );
        }

        //LL: these are shown only if Polar remains, i.e. prohibitPolar is false:
        if (!prohibitPolar) {
            if (secondaryValueAxis) {
                errMsg.push(
                    '"Show as PolarChart" is requested, but Extra Value Axes are defined.<br>' +
                        'Main Value Axis will be used to show Chart Values'
                );
            }
            if (useRangeSelector) {
                errMsg.push('Sorry, RangeSelector does not work together with Polar charts.'); //LL: Leo suggestion
            }
        }

        return {
            prohibitPolar: prohibitPolar,
            errMsg: errMsg,
            wrongChartType: wrongChartType,
            secondaryValueAxis: secondaryValueAxis,
            useRangeSelector: useRangeSelector
        };
    }

    //public static setChartInstanceComponent_React(chartComponent) {}

    public static createChartOptions(
        wParams: IWParams,
        _paramsOwn,
        element,
        _theme: IValuesCollection,
        _widgetDescriptor,
        glob: IGlob,
        chartInstance_React?,
        callback?
    ) {
        let co = {};

        let defaults = {
            title: 'empty Chart',

            wParams: {}, // actual wParams of Chart: chartType, rotatedXY, argumentAngle, palette

            // - callbacks:
            getDataSource: Utils.emptyArrayFunction,
            getArgumentField: Utils.emptyReturnFunction,
            getSizeField: Utils.emptyReturnFunction,
            getSeries: Utils.emptyArrayFunction,
            getPieSeries: Utils.emptyListFunction,
            onPointClick: Utils.emptyFunction,
            onSeriesClick: Utils.emptyFunction,
            onPointSelectionChanged: Utils.emptyFunction,
            getCategories: Utils.emptyArrayFunction,
            getArgumentAndPointLabels: Utils.emptyListFunction,
            getChartTitle: Utils.emptyReturnFunction,
            obj: null
        };

        let config = $.extend(true, {}, defaults, _paramsOwn);

        let chartOptions: IChartOptions = null;
        let pieChartOptions: any = null;

        let createXY = true;
        let createPie = true;
        let geometry = config.wParams.geometry;

        if (geometry != null) {
            createXY = ChartOptionsController.hasXY(geometry);
            createPie = ChartOptionsController.hasPie(geometry);
        }
        //LL: when "both": adjust by current chartType, otherwise we always create XY and Pie ChartOptions
        let isXY = ChartOptionsController.getIsXY(wParams.chartType);

        if (geometry === 'both') {
            if (isXY) {
                createPie = false;
            } else {
                createXY = false;
            }
        }

        // - legend:
        let legend: any = LegendWrapper.createLegend(wParams, isXY, _theme);

        // - argType:

        let argLabelsFormatIsDefault =
            wParams.argumentAxis.labelsFormat == null ||
            wParams.argumentAxis.labelsFormat === '' ||
            wParams.argumentAxis.labelsFormat === 'default';

        let argType = 's';
        let argTimePart; //LL: format for Time Parts is in wParams.argumentAxis.labelsFormat

        let oArgumentType = ChartFunctionsWrapper.evalArgumentsType(wParams, glob); // return { argType: argType, argTimePart: argTimePart  }
        argType = oArgumentType.argType;
        argTimePart = oArgumentType.argTimePart;

        // - yType:  evaluated type of Y-axis

        let yType = 's';
        let yTimePart; //LL: format for Time Parts is in wParams.valueAxis.labelsFormat
        let yLabelsFormatIsDefault =
            wParams.valueAxis.labelsFormat == null ||
            wParams.valueAxis.labelsFormat === '' ||
            wParams.valueAxis.labelsFormat === 'default';

        let ArgumentAndPointLabels; //LL: define before function customizePointFunc(point)
        let ArgumentAndPointLabels_Groups;
        let arrArgumentAndPointLabels;
        let arrArgumentAndPointLabels_Groups;

        let maxValueC, minValueC; //LL: define before function customizePointFunc(point)

        let seriesCnt; //LL: define before function customizePointFunc(point)

        // //LL: SBS+Stack onlyOneLabelPerStack
        // // To use:  customizeLabel:  customizeLabelFunc,  - in ChartOptions
        // function customizeLabelFunc(point) {
        //     //  This function should return an object with options that will be changed for a certain label.
        //     //  Return Value: Point Label

        //     //LL:  here change visibility of point labels when:
        //     ////  ser.tag.stack is already set
        //     //ser.tag.upperInStack = true;
        //     //ser.tag.visibleForStack = stack;
        //     //ser.label.visible = true;
        //     //LL: So only change to False
        //     let tag = point.series.tag;

        //     if (tag != null) {
        //         if (tag.upperInStack === true) {
        //             if (tag.stack !== tag.visibleForStack) {
        //                 return {
        //                     visible: false
        //                 };
        //             }
        //         }
        //     }

        //     return {};
        // }

        let applyPaletteForSingleSeriesPoints = false;

        if (wParams.applyPaletteForSingleSeriesPoints != null) {
            applyPaletteForSingleSeriesPoints = wParams.applyPaletteForSingleSeriesPoints;
        }
        let paletteColors;
        let paletteColorsIndex = 0;

        // - Color Mapping

        // To use:  customizePoint:  customizePointFunc,  - in ChartOptions  and Pie
        function customizePointFunc(point) {
            //  - customizePoint
            //  Return Value: Point configuration   A configuration object for the point

            // By default, all points on a chart are displayed identically.
            // But you can specify different appearance for certain points using the customizePoint field.
            // Assign a function to this field.
            // This function should return an object with options that must be changed for a specific point.
            // Refer to the point object description to learn about the options that can be changed.
            //    NOTE: The hoverMode and selectionMode options cannot be changed using the customizePoint option.

            //  When implementing a callback function for this option, use the argument or value of a point. They can be accessed using the following fields of the function's parameter.
            //    •argument   Represents the argument of the point.
            //    •value      Represents the value of the point.
            //    •tag        Represents the tag of the point.
            //    •seriesName Represents the name of the series to which the point belongs.
            //    •index      Represents the index of the point in the points array.

            //   In the range bar and range area series ...   And candle stick and stock ...

            let palColor;

            if (
                applyPaletteForSingleSeriesPoints === true &&
                seriesCnt === 1 &&
                paletteColors != null &&
                paletteColors.length > 0
            ) {
                palColor = paletteColors[paletteColorsIndex];
                if (paletteColorsIndex < paletteColors.length - 1) {
                    paletteColorsIndex++;
                } else {
                    paletteColorsIndex = 0;
                }
            }

            let colorMapping = wParams.externalFunctions.colorMapping;

            //LL:  ???  What if Color is set for Args and also for Grouping ???
            //     -  Grouping has priority

            //LL: colorMapping for Grouping:
            //LL: tag.x, tag.x2, tag.x3 contain LABELS, i.e. joined Attrib or Label
            //LL: NEW for ColorMapping: tag.x_ref, tag.x2_ref, tag.x3_ref contain REFER, i.e. for type 'e' joined Attrib or attribRefer
            //    May be both x2 and x3 or just one or none
            //    Also actual grouping value can be in tag.groupOnly or in tag.group and tag.stack

            //LL: HERE ONLY WHEN NO GROUPING !!!   When Grouping, color is set for series

            if (point.series.tag != null) {
                let isGrouping = point.series.tag.x2_ref != null || point.series.tag.x3_ref != null;
                let dataSourceID;

                if (point.series.tag.counters != null) {
                    dataSourceID = point.series.tag.counters.dataSourceID;
                }
                if (dataSourceID == null) {
                    dataSourceID = 1;
                }

                if (isGrouping) {
                    //LL:  no need this, color for groupped series is applied in apply_mappedColor(ser)
                    //                   and both for single and double grouping
                    //  the main problem is that DataQuery grouping attribute must be the same as colorMapping keys !

                    //LL: it concerns colorMapping (~~ Lookup), but not cmfn !  See it below

                    if (wParams.useColoringByDataQuery === true) {
                        let c = ChartOptionsController.evalColorByMapping(
                            point,
                            point.series.tag,
                            maxValueC,
                            minValueC,
                            wParams.externalFunctions.colorMapping
                        );
                        if (c != null) {
                            return { color: c };
                        }
                    }
                } //  isGrouping
                else {
                    //LL:  useColoringByDataQuery has highest priority (it is set when Automatic and ColoringByDataQuery)
                    if (wParams.useColoringByDataQuery === true) {
                        let c = ChartOptionsController.evalColorByMapping(
                            point,
                            point.series.tag,
                            maxValueC,
                            minValueC,
                            wParams.externalFunctions.colorMapping
                        );
                        if (c != null) {
                            return { color: c };
                        }
                    }

                    let argAttr;

                    if (point.series.tag.x_ref != null) {
                        argAttr = point.series.tag.x_ref;
                    }

                    //LL: wParams.applyEntityColorMapping and wParams.applyEntityColorMapping_whenExist

                    //LL: look if colorMapping is defined for Args:
                    if (argAttr != null) {
                        let colorMappingFound = false;
                        let apl = ArgumentAndPointLabels;
                        let counterId = point.series.tag.counters.counterId;

                        if (arrArgumentAndPointLabels != null && arrArgumentAndPointLabels.length > counterId) {
                            apl = arrArgumentAndPointLabels[counterId];
                        }

                        let applyEntityColorMapping_any =
                            wParams.applyEntityColorMapping === true ||
                            wParams.applyEntityColorMapping_whenExist === true;

                        if (colorMapping != null && applyEntityColorMapping_any) {
                            //LL: either applyEntityColorMapping or applyEntityColorMapping_whenExist(is when "Automatic"):
                            //LL: argAttr here x_ref or x_color (from X1 or XC)  //LL: No, see above
                            let cmArg =
                                colorMapping[ChartOptionsController.build_colorMapping_argument(argAttr, dataSourceID)];

                            if (cmArg != null) {
                                colorMappingFound = true;

                                let arg = point.argument;

                                //LL: ?????   (no, apl contains colors by XC.  )
                                //LL: use it again with "if"
                                if (point.series.tag.x_color != null && wParams.useColoringByDataQuery === true) {
                                    if (apl != null) {
                                        if (apl[arg] != null) {
                                            let pl = apl[arg].color;
                                            if (pl != null && pl != '') {
                                                arg = pl;
                                            }
                                        }
                                    }
                                }

                                let argColor = cmArg[arg];

                                //LL: either applyEntityColorMapping or applyEntityColorMapping_whenExist(is when "Automatic"):
                                if (wParams.applyEntityColorMapping === true) {
                                    if (argColor == null) {
                                        argColor = cmArg[COLOR_MAP_UNDEF_KEY];
                                    }
                                    if (argColor == null) {
                                        argColor = COLOR_MAP_UNDEF_COLOR;
                                    }
                                }

                                if (argColor != null) {
                                    return { color: argColor };
                                }
                            }
                        } // colorMapping != null

                        // - colorMappingForNumeric, etc:
                        if (!colorMappingFound) {
                        }
                    } // if (argAttr != null)
                } //  no grouping
            }

            if (palColor != null) {
                return { color: palColor };
            }
        }

        // - Scroll Or Zoom:  with dxRangeSelector

        // LL: - useScrollOrZoom =  'scroll', 'zoom', 'none';

        //LL: for scroll or zoom:

        // - For SCROLL: Keep Value Axis Range:
        //   To keep the visible range of the chart's value axis,
        //   set the Chart's adjustOnZoom property to false when scrolling the argument axis.

        // - For ZOOM:  Value Axis adjustment
        //   To zoom the chart's selected region, the value axis' visible range must change
        //   based on current minimum and maximum chart values.
        //   For this purpose, the Chart's adjustOnZoom property is set to true by default

        //------- about adjustOnZoom --------------
        //   adjustOnZoom -
        //     Indicates whether or not to adjust a value axis to the current minimum and
        //     maximum values of a zoomed chart.

        //   You can use the dxRangeSelector widget to perform zooming on the Chart widget.
        //   In such an instance, the range selector and chart will have the same argument scale (axis).
        //   When an end-user selects a range in the range selector, the chart displays this range
        //   in the argument axis and the corresponding series part only.
        //   The adjustOnZoom property determines whether or not to change the value axis' visible range,
        //   so that its minimum and maximum values correspond to the values of the lowest and highest
        //   points of the currently visible series part.
        //---FIN---- about adjustOnZoom --------------

        //LL: set to false for scroll, set to true for zoom
        //LL: adjustOnZoom does not work when arguments are of string type
        let adjustOnZoom = true; // default
        if (wParams.scrollOrZoom.useScrollOrZoom === 'scroll') {
            adjustOnZoom = false;
        }

        // - Pie labels:

        let showPieLabelsThreshold = wParams.labelPie.showPieLabelsThreshold;

        function showLabels(itemsNum) {
            //LL: 20 is pure experimental
            if (!wParams.labelPie.showPieLabelsBool) {
                return false;
            } else if (showPieLabelsThreshold !== 0 && itemsNum > showPieLabelsThreshold) {
                return false;
            } else {
                return true;
            }
        }

        function getPointSelectionMode() {
            if (wParams.multiSelectPoints == null) {
                return 'single';
            } else if (wParams.multiSelectPoints) {
                return 'multiple';
            } else {
                return 'single';
            }
        }

        let title_font_color = _theme[themeFields.title_color];
        let title_horizontalAlignment = _theme[themeFields.title_horizontalAlignment];
        let title_verticalAlignment = _theme[themeFields.title_verticalAlignment];
        let title_subTitle = _theme[themeFields.title_subTitle];
        let title_ownTitle = _theme[themeFields.title_ownTitle];
        let titleFont: any = {
            size: 'small',
            weight: 'bold',
            color: title_font_color
        }; // size def = 28
        //LL: 25.06.25:
        let foT = FontWrapper.createFontObj_fromTheme(wParams, _theme, themeFields.title_font);
        _.extend(titleFont, foT); // shallow

        //LL: 25.06.25: SubTitle own params:
        let subTitleFont: any;
        let title_subTitle_useOwnFont = _theme[themeFields.title_subTitle_useOwnFont]; // true default
        let title_subTitle_font_color = _theme[themeFields.title_subTitle_color];
        if (title_subTitle_useOwnFont === false) {
            subTitleFont = _.clone(titleFont); // shallow
        } else {
            subTitleFont = {
                size: 'small',
                weight: 'bold',
                color: title_subTitle_font_color
            }; // size def = 28
            let foT2 = FontWrapper.createFontObj_fromTheme(wParams, _theme, themeFields.title_subTitle_font);
            _.extend(subTitleFont, foT2); // shallow
        }

        function getChartTitleConditional() {
            if (wParams.showChartTitle) {
                let useDefault = wParams.useDefaultChartTitle;
                let titleDefault = config.getChartTitle();
                let emptyDefault = titleDefault === '';
                useDefault = useDefault && !emptyDefault;
                let ChartTitle = wParams.title;
                if (useDefault) {
                    ChartTitle = titleDefault;
                }
                if (title_ownTitle != null && title_ownTitle.trim() !== '') {
                    ChartTitle = title_ownTitle;
                }
                return ChartTitle;
            } else {
                return null;
            } //LL: try, does not matter
        }

        //LL: zoomAndPan for DevExpr ver 18.2
        function get_zoomAndPan(allowZoom, allowScroll) {
            if (allowZoom && allowScroll) {
                return 'both';
            } else if (allowZoom) {
                return 'zoom';
            } else if (allowScroll) {
                return 'pan';
            } else {
                return 'none';
            }
        }

        //LL:   in onPointSelectionChanged
        function addToSelections(
            selections,
            arg_attribute,
            curArg,
            tag_ser,
            field_intervals,
            field_clickToFilterAttribute,
            dataSourceID_ser,
            arg_syntaxTree?,
            arg_rettype?,
            isC2F_Multi? //LL: if true, field_intervals and field_clickToFilterAttribute are not fields, actual
        ) {
            // When there are several DataSource Portions, one of them can define C2F-argument, but another does not.
            // Also Arg can be different
            // Also theoretically there can be different dataSourceID (so store it, but not used by EU)
            //
            // So, create not arrays args, args2, args3,
            //     but array of actual selections [ { attribute, selectedVals, tag_ser, dataSourceID(?) } ]

            //LL:  ==============================
            //  I presume (but it can be not true !), that an "attribute" has equal tag_ser[field_intervals]
            //     and tag_ser[field_clickToFilterAttribute]  when multi-dataDescr
            //  Otherwise there must be elements in "selections" with same "attribute" and different that fields
            //LL:  ==============================

            //LL: change back &lt to "<"
            //    argText = argText.replace(/</gi, '&lt').replace(/>/gi, '&gt');
            if (curArg != null && typeof curArg === 'string') {
                curArg = curArg.replace(/&lt/gi, '<').replace(/&gt/gi, '>');
            }

            //LL: { attribute, selectedVals, tag_ser, dataSourceID(?) }
            let existsAttribute = false;

            if (isC2F_Multi !== true) {
                for (let k = 0; k < selections.length; k++) {
                    //LL: arg_attribute = '' for Expressions, so maybe more complex: compare arg_syntaxTree, arg_regtype
                    if (arg_attribute === selections[k].attribute) {
                        let selectedVals = selections[k].selectedVals;
                        let existsInSeletions = false;
                        for (let kk = 0; kk < selectedVals.length; kk++) {
                            if (curArg === selectedVals[kk]) {
                                existsInSeletions = true;
                                break;
                            }
                        }
                        if (!existsInSeletions) {
                            selectedVals.push(curArg);
                        }

                        existsAttribute = true;
                        break;
                    }
                }
            }

            if (!existsAttribute) {
                selections.push({
                    attribute: arg_attribute,
                    selectedVals: [curArg],
                    tag_ser: tag_ser,
                    field_intervals: field_intervals,
                    field_clickToFilterAttribute: field_clickToFilterAttribute,
                    dataSourceID: dataSourceID_ser,
                    syntaxTree: arg_syntaxTree,
                    rettype: arg_rettype,
                    isC2F_Multi: isC2F_Multi //LL: if true, field_intervals and field_clickToFilterAttribute are not fields, actual
                });
            }
        }

        if (createXY) {
            //  categories after dataSource:

            //LL: add dataSourcePortions for multi queries, to determine boundaries for different queries in whole dataSource
            config.getDataSource(
                function (
                    dataSource,
                    dataTypes,
                    maxY,
                    minY,
                    maxA,
                    minA,
                    maxYC,
                    minYC,
                    dataSourceFields,
                    stackValues,
                    dataSourcePortions,
                    dataOneDim
                ) {
                    let chartWidgetObj = config.obj;

                    //LL: Leo wants the same when argCount is 1
                    //LL: special case for Leo:  Diff Pct in Point Labels
                    //  Conditions: 1 Query, 1 Y, X, X2(SBS), numeric data type, sort by Arg, SBS
                    //LL: without sort by Arg
                    let showDiffPct = false;
                    let tfm = chartWidgetObj.paramsOwn.wParams.labelXY.textFormat_standard_multi;

                    if (tfm != null && tfm.includes('diffPercent')) {
                        showDiffPct = true;
                    }

                    if (showDiffPct) {
                        if (chartWidgetObj.countersMultiAQL != null && chartWidgetObj.countersMultiAQL.length == 1) {
                            let isNumeric = dataTypes[0] === 'i' || dataTypes[0] === 'r';
                            let counters = chartWidgetObj.countersMultiAQL[0]; //  or chartWidgetObj.countersMain

                            //LL: Leo wants the same when argCount is 1
                            if (counters.yCount === 1 && counters.argCount === 1 && isNumeric) {
                                //LL: same as "anotherWay" below
                                let prevVal = undefined; // not null !
                                let dataSource2 = _.map(dataSource, function (item: any) {
                                    let obj: any = _.clone(item);
                                    let yVal = obj['0_y_value_0'];
                                    if (prevVal === undefined) {
                                        //  item is 1st in group, no DiffPct
                                        prevVal = yVal;
                                        obj.DiffPct = null;
                                    } else {
                                        //  next items
                                        if (prevVal === 0 || prevVal == null) {
                                            obj.DiffPct = null;
                                        } else {
                                            obj.DiffPct = ((yVal - prevVal) / prevVal) * 100; // (C2-C1)/C1*100
                                        }
                                        prevVal = yVal;
                                    }
                                    return obj;
                                });
                                dataSource = dataSource2;
                            }

                            if (
                                counters.yCount === 1 &&
                                counters.argCount === 2 &&
                                counters.hasX3 != true &&
                                isNumeric
                            ) {
                                //  dataSource - arr:   {  name: 1, groupArg: false,  false: 302 }
                                //LL: consider that is SORTED by "name", and then by "groupArg"   !!!
                                //    data type is Numeric

                                //   by Leo:
                                //  C1 should be blank.
                                //  For C2, the value is (C1-C2)/C1*100 %
                                //  For C3, the value is (C2-C3)/C2*100 %
                                //  LL: maybe C2-C1 ?   Yes

                                //LL: for Date Args use dateInt, not name
                                let argIsDate = false; //LL: check by 1st item

                                if (dataSource != null && dataSource.length > 0) {
                                    argIsDate = dataSource[0].dateInt != null;
                                }

                                //LL:  another way
                                let anotherWay = true; //LL: my flag

                                if (anotherWay) {
                                    let argNames: any = {};
                                    let dataSource2 = _.map(dataSource, function (item) {
                                        let obj = _.clone(item);
                                        let name = argIsDate ? obj.dateInt : obj.name;

                                        if (name != null) {
                                            let curName = argNames[name];
                                            if (curName == null) {
                                                //  item is 1st in group, no DiffPct
                                                let groupArg = obj.groupArg;
                                                let curVal = obj[groupArg];
                                                argNames[name] = curVal;
                                                obj.DiffPct = null;
                                            } else {
                                                //  next items
                                                let groupArg = obj.groupArg;
                                                let curVal = obj[groupArg];
                                                let prevVal = argNames[name];
                                                if (prevVal === 0) {
                                                    obj.DiffPct = null;
                                                } else {
                                                    obj.DiffPct = ((curVal - prevVal) / prevVal) * 100; // (C2-C1)/C1*100
                                                }
                                                argNames[name] = curVal;
                                            }
                                        }
                                        return obj;
                                    });

                                    dataSource = dataSource2;
                                }
                            }
                        }
                    } //  ShowDiffPct

                    //LL: yType - evaluated type of Y-axis
                    let oValueType = ChartFunctionsWrapper.evalValuesType(wParams, dataTypes, glob); // return { yType: yType, yTimePart: yTimePart  }

                    yType = oValueType.yType;
                    yTimePart = oValueType.yTimePart;

                    //LL: add argType, important for mixed Queries. Also see below old categories[i].toString()
                    let ccc = config.getCategories(dataSource, dataSourceFields, stackValues, argType);
                    let categories = ccc.categories;
                    let categoriesExtended = ccc.categoriesExtended;

                    //LL:  return { APL: APL, APLG: APLG, arrAPL: arrAPL, arrAPLG: arrAPLG };
                    let aapl = config.getArgumentAndPointLabels(dataSource, dataSourcePortions);
                    ArgumentAndPointLabels = aapl.APL;
                    ArgumentAndPointLabels_Groups = aapl.APLG;
                    arrArgumentAndPointLabels = aapl.arrAPL;
                    arrArgumentAndPointLabels_Groups = aapl.arrAPLG;

                    maxValueC = maxYC;
                    minValueC = minYC;

                    const chartTypes = ChartPropsManager.get_ChartTypes_Multi(wParams.externalFunctions.attrQueryMulti);
                    const secondaryValueAxes = ChartPropsManager.get_SecondaryValueAxis_Multi(
                        wParams.externalFunctions.attrQueryMulti
                    );

                    let series = config.getSeries(
                        ArgumentAndPointLabels,
                        ArgumentAndPointLabels_Groups,
                        arrArgumentAndPointLabels,
                        arrArgumentAndPointLabels_Groups,
                        minValueC,
                        maxValueC,
                        yType,
                        chartTypes,
                        secondaryValueAxes
                    );

                    seriesCnt = series.length;

                    if (applyPaletteForSingleSeriesPoints === true && seriesCnt === 1) {
                        paletteColors = DevExprPaletteManager.getVariatedColors2(
                            wParams.palette,
                            wParams.paletteExtensionMode,
                            dataSource.length
                        );
                    }

                    // - about extendDataSource_BySeries_2:
                    //LL: sometimes, when double grouping, this operation adds very many data lines to DataSource.
                    //       And Chart is rendered unexpectedly slow
                    //    There is example when initial DataSource.length = 241, after = 4740  (there were 237 series by double grouping)

                    //  It was done as recommendation by DevExpress
                    //  Reported by OE 2 years ago - https://www.devexpress.com/Support/Center/Question/Details/T170408
                    //    recommendation by DevExpress: Change data so that each argument has a defined value or "null" for each series.

                    //LL: done for all ChartTypes, were complaints that args order is wrong
                    //   Initially it was called only for Lines and Areas.
                    ChartFunctionsWrapper.extendDataSource_BySeries_2(
                        categoriesExtended,
                        series,
                        dataSource,
                        wParams.emptyValuesAsZero,
                        wParams.onlyOneLabelPerStack
                    );

                    //LL: update Series by singleSeriesColor
                    if (wParams.singleSeriesColor != null) {
                        if (series.length === 1) {
                            if (series[0].color == null) {
                                series[0].color = wParams.singleSeriesColor;
                            }
                        }
                    }
                    if (wParams.useSingleColorForAll === true && wParams.singleSeriesColor != null) {
                        for (let i = 0; i < series.length; i++) {
                            //if (series[i].color == null) {
                            series[i].color = wParams.singleSeriesColor;
                            //}
                        }
                    }

                    //LL: Border Color for Bars:  make it simple:
                    if (wParams.seriesBorderVisible === true) {
                        for (let i = 0; i < series.length; i++) {
                            series[i].border = {
                                visible: true,
                                color: wParams.seriesBorderColor,
                                width: wParams.seriesBorderWidth
                            };
                        }
                    }

                    // - customStyles:
                    CustomStylesWrapper.updateSeriesByCustomStyles(wParams, series);

                    // - strips:

                    let StripsWrapperObj = new StripsWrapper(wParams);

                    let stripsObj = StripsWrapperObj.createStrips(argType, yType, dataOneDim, glob);

                    let stripsX = stripsObj.stripsX;
                    let stripsY = stripsObj.stripsY;
                    let stripsA = stripsObj.stripsA;
                    let strips_hasAsPercentX = stripsObj.strips_hasAsPercentX;
                    let strips_hasAsPercentY = stripsObj.strips_hasAsPercentY;
                    let strips_hasAsPercentA = stripsObj.strips_hasAsPercentA;

                    // - constantLines:

                    //LL: or (if outside) private static ConstantLinesWrapperObj = new ConstantLinesWrapper(wParams);
                    let ConstantLinesWrapperObj = new ConstantLinesWrapper(wParams);

                    let constantLinesObj = ConstantLinesWrapperObj.createConstantLines(
                        argType,
                        yType,
                        dataOneDim,
                        glob
                    );

                    let constantLinesX = constantLinesObj.constantLinesX;
                    let constantLinesY = constantLinesObj.constantLinesY;
                    let constantLinesA = constantLinesObj.constantLinesA;
                    let constantLines_hasAsPercentX = constantLinesObj.constantLines_hasAsPercentX;
                    let constantLines_hasAsPercentY = constantLinesObj.constantLines_hasAsPercentY;
                    let constantLines_hasAsPercentA = constantLinesObj.constantLines_hasAsPercentA;

                    // - breaks:

                    let BreaksWrapperObj = new BreaksWrapper(wParams);

                    let breaksObj = BreaksWrapperObj.createBreaks(argType, yType);

                    let breaksX = breaksObj.breaksX;
                    let breaksY = breaksObj.breaksY;

                    // - argumentAxis:

                    let ArgumentAxisWrapperObj = new ChartAxisWrapper(wParams, 'x');
                    let argumentAxisObj: any = ArgumentAxisWrapperObj.createAxis(
                        argType,
                        stripsX,
                        constantLinesX,
                        breaksX,
                        ArgumentAndPointLabels,
                        argTimePart,
                        argLabelsFormatIsDefault,
                        _theme
                    );
                    let argumentAxisOption: any = argumentAxisObj.axis;
                    let argumentAxis_useCategories = argumentAxisObj.useCategories;
                    let argumentAxis_useLabelFormat = argumentAxisObj.useLabelFormat;

                    // - main valueAxis:
                    //  http://js.devexpress.com/Documentation/Howto/Data_Visualization/Charts/Multi-Series_Chart/?version=14_2#Multi-Axis_Chart

                    //LL: for Dates and integer
                    //  valueType: Default Value: undefined   Accepted Values: 'numeric' | 'datetime' | 'string'
                    //  In some scenarios, you may need the type of the values that are specified in the data source
                    //    to be converted to another type. In this instance, specify the desired type for
                    //    the axis values using the valueType property.
                    // ----------------------------

                    let ValueAxisWrapperObj = new ChartAxisWrapper(wParams, 'y');
                    let valueAxisObj: any = ValueAxisWrapperObj.createAxis(
                        yType,
                        stripsY,
                        constantLinesY,
                        breaksY,
                        ArgumentAndPointLabels,
                        yTimePart,
                        yLabelsFormatIsDefault,
                        _theme
                    );
                    let mainValueAxisOption: any = valueAxisObj.axis;
                    let valueAxis_useLabelFormat = valueAxisObj.useLabelFormat;

                    // - auxAxis: []  // Multiple axis.  AuxAxis with same properties + "name"

                    //LL:   valueAxis can be Object or Array
                    //      argumentAxis is always Object

                    let ValueAxisArr = [];
                    let aTimeParts = {};
                    let aDefs = {};
                    let param_auxValueAxis = wParams.valueAxis.auxAxis;
                    if (param_auxValueAxis != null && param_auxValueAxis.length > 0) {
                        ValueAxisArr.push(mainValueAxisOption);

                        let paaDefault = {
                            show: true,
                            visible: true, // = show
                            showGridLines: false,
                            showLine: true,
                            showAxisTicks: false,
                            showMinorTicks: false,
                            showMinorGridLines: false,
                            showLabels: true,
                            usePalette: true,
                            colorSeries: '#ff0080',
                            tickDateIntervals: 1,
                            synchronizedOn_Integer: 0
                            //LL: rem:  synchronizedOn: 0
                        };

                        for (let i = 0; i < param_auxValueAxis.length; i++) {
                            let paa: any = $.extend(true, {}, paaDefault, param_auxValueAxis[i]);

                            let oValueType = ChartFunctionsWrapper.evalAuxAxisType(wParams, paa.name, glob); // return { yType: yType, yTimePart: yTimePart  }
                            let aaType = oValueType.yType;
                            let aaTimePart = oValueType.yTimePart;
                            if (aaTimePart != null && aaTimePart !== 'none') {
                                aTimeParts[paa.name] = aaTimePart;
                            }

                            let aaLabelsFormatIsDefault =
                                paa.labelsFormat == null || paa.labelsFormat === '' || paa.labelsFormat === 'default';

                            //LL: prepare for ChartAxisWrapper:
                            paa.axisLineVisible = paa.showLine;
                            paa.labelsVisible = paa.showLabels;
                            paa.gridLinesVisible = paa.showGridLines;
                            paa.ticksVisible = paa.showAxisTicks;
                            paa.minorGridLinesVisible = paa.showMinorGridLines;
                            paa.minorTicksVisible = paa.showMinorTicks;

                            paa.axisType = paa.type;

                            paa.synchronizedOn_Integer = paa.synchronizedOn;
                            paa.synchronizedOn_Date = paa.synchronizedOn;

                            paa.minValue_Integer = paa.minValue;
                            paa.minValue_Real = paa.minValue;
                            paa.minValue_Date = paa.minValue;
                            paa.maxValue_Integer = paa.maxValue;
                            paa.maxValue_Real = paa.maxValue;
                            paa.maxValue_Date = paa.maxValue;

                            let AuxAxisWrapperObj = new ChartAxisWrapper(wParams, 'a', paa);

                            let strips: any = null;
                            let constantLines: any = null;
                            if (stripsA[paa.name] != null) {
                                strips = stripsA[paa.name].strips;
                            }
                            if (constantLinesA[paa.name] != null) {
                                constantLines = constantLinesA[paa.name].constantLines;
                            }

                            const isUsed = ChartPropsManager.isUsed_SecondaryValueAxis_Multi(
                                wParams.externalFunctions.attrQueryMulti,
                                paa.name
                            );

                            if (isUsed !== true) {
                                aaType = null;
                            }

                            //LL: no Breaks for AUX
                            const auxAxisObj = AuxAxisWrapperObj.createAxis(
                                aaType,
                                strips,
                                constantLines,
                                null,
                                ArgumentAndPointLabels,
                                aaTimePart,
                                aaLabelsFormatIsDefault,
                                _theme
                            );

                            let aaOption = auxAxisObj.axis;

                            ValueAxisArr.push(aaOption);
                            aDefs[paa.name] = {
                                aType: aaType,
                                paa: paa,
                                useLabelFormat: auxAxisObj.useLabelFormat
                            };
                        }
                    }

                    const labelXY = SeriesXY_PointLabel_Wrapper.createPointLabelXY(
                        wParams,
                        ArgumentAndPointLabels,
                        ArgumentAndPointLabels_Groups,
                        arrArgumentAndPointLabels,
                        arrArgumentAndPointLabels_Groups,
                        chartWidgetObj,
                        argTimePart,
                        yTimePart,
                        aTimeParts,
                        _theme
                    );

                    function legendXY_customizeText(seriesInfo) {
                        //   seriesName  seriesIndex  seriesColor
                        //LL: ONLY REACT
                        let ser;

                        if (chartInstance_React != null) {
                            ser = chartInstance_React.getSeriesByPos(seriesInfo.seriesIndex);
                        }

                        if (ser != null) {
                            let tag = ser.tag;

                            if (tag.isAuxAxis === true) {
                                let serTitle = tag.auxAxisTitle;
                                if (serTitle == null || serTitle === '') {
                                    serTitle = ser.axis;
                                }
                                if (wParams.legend.includeAxisNameIntoNames !== false) {
                                    return seriesInfo.seriesName + ' (axis=' + serTitle + ')';
                                } else {
                                    return seriesInfo.seriesName;
                                }
                            } else {
                                return seriesInfo.seriesName;
                            }
                        } else {
                            return seriesInfo.seriesName;
                        }
                    }

                    function legendXY_customizeHint(seriesInfo) {
                        //LL: better use getSeriesByPos or getSeriesByName, but element is unknown here  (?)
                        for (let i = 0; i < series.length; i++) {
                            if (series[i].name === seriesInfo.seriesName) {
                                let serTag = series[i].tag;
                                if (serTag != null && serTag.nameOld != null) {
                                    return 'overriden name: ' + serTag.nameOld;
                                }
                            }
                        }
                    }

                    legend.customizeText = legendXY_customizeText;
                    legend.customizeHint = legendXY_customizeHint;

                    //    "barPadding", "barGroupPadding" in percents, DevExpr uses fractional 0-1
                    let barPadding = wParams.barPadding != null ? wParams.barPadding / 100 : 0.1;
                    let barGroupPadding = wParams.barGroupPadding != null ? wParams.barGroupPadding / 100 : 0.3; // 0.3 default in DevExpr

                    //LL: BAR WIDTH - for each Series, for use in SubTitles ??????? !!!!!!!

                    //LL: annotations - "light" version, not full wrapping, only for SubTitles
                    let subTitles_bg_color = _theme[themeFields.pointLabels_subTitles_backgroundColor];
                    let subTitles_borderVisible = _theme[themeFields.pointLabels_subTitles_borderVisible];
                    let subTitles_border_color = _theme[themeFields.pointLabels_subTitles_borderColor];
                    let subTitles_font_color = _theme[themeFields.pointLabels_subTitles_fontColor];
                    let subTitles_font: any = FontWrapper.createFontObj_fromTheme(
                        wParams,
                        _theme,
                        themeFields.pointLabels_subTitles_font
                    );
                    subTitles_font.color = subTitles_font_color;

                    let subTitles_width = _theme[themeFields.pointLabels_subTitles_width];
                    //let subTitles_height = _theme[themeFields.pointLabels_subTitles_height]; //LL: don't use height
                    let subTitles_paddingLeftRight = _theme[themeFields.pointLabels_subTitles_paddingLeftRight];
                    let subTitles_paddingTopBottom = _theme[themeFields.pointLabels_subTitles_paddingTopBottom];
                    let subTitles_adjustTop = _theme[themeFields.pointLabels_subTitles_adjustTop];
                    let subTitles_argumentAxisLabelsIndentation =
                        _theme[themeFields.pointLabels_subTitles_argumentAxisLabelsIndentation];

                    let annotations = []; // Also CommonAnnotationSettings !!!
                    let subTitleCnt = 0;

                    _.each(categories, (cat: any) => {
                        _.each(series, (ser: any) => {
                            let subTitleValue = ser.tag.groupSubTitleValue != null ? ser.tag.groupSubTitleValue : '';
                            if (ser.tag.groupSubTitleValue != null) {
                                subTitleCnt++;
                            }
                            let text = LabelsFormatWrapper.getFormatted(
                                subTitleValue,
                                null,
                                ser.tag,
                                'SBT_formats',
                                wParams.currency,
                                'Labels'
                            );
                            annotations.push({
                                argument: cat,
                                series: ser.name,
                                type: 'text',
                                text: text, // "Ann",  //"Annotation text",
                                //color: "yellow",
                                color: subTitles_bg_color != null ? subTitles_bg_color : 'yellow',
                                //font: {color: subTitles_font_color},
                                font: subTitles_font,
                                border: { visible: subTitles_borderVisible, color: subTitles_border_color },
                                shadow: { blur: 0 }, // no shadow
                                arrowLength: 0, // 14 default
                                arrowWidth: 0, // 14 default
                                paddingTopBottom: subTitles_paddingTopBottom, //2, // 10 default
                                paddingLeftRight: subTitles_paddingLeftRight, //2, // 10 default
                                wordWrap: 'none',
                                textOverflow: 'none', // 'ellipsis' (default) | 'hide' | 'none' //LL: hide means Label without Text
                                opacity: 1, // opaque  default 0.9
                                //height: subTitles_height, // may be null //LL: don't use height
                                width: subTitles_width, // may be null
                                //  Moves the annotation vertically
                                // The number assigned to this property specifies the shift in pixels.
                                // A negative number shifts the annotation up and a positive number shifts it down.
                                offsetY: subTitles_adjustTop, // 0, //10,
                                value: 0
                            });
                        });
                    });
                    //LL: Free place for SubTitles:
                    // argumentAxis: argumentAxisOption   label.indentFromAxis  10 default
                    if (subTitleCnt > 0) {
                        argumentAxisOption.label.indentFromAxis = subTitles_argumentAxisLabelsIndentation;
                    } else {
                        annotations = null;
                    }

                    chartOptions = {
                        annotations: annotations,
                        commonSeriesSettings: {
                            type: wParams.chartType,
                            argumentField: config.getArgumentField(),
                            sizeField: config.getSizeField(),
                            ignoreEmptyPoints: true, // for line, area  // By default, if a data source has data points with a null argument or value, a chart may draw series with unnecessary gaps between points.
                            label: labelXY,

                            minBarSize: wParams.minBarSize != null ? wParams.minBarSize : 0,
                            barPadding: barPadding,
                            bar: {
                                ignoreEmptyPoints: !wParams.showEmptyBars
                            },
                            stackedbar: {
                                ignoreEmptyPoints: !wParams.showEmptyBars
                            },
                            fullstackedbar: {
                                ignoreEmptyPoints: !wParams.showEmptyBars
                            },

                            line: {
                                //LL: settings for "line" charts
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            stackedline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            fullstackedline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            spline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            stackedspline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            fullstackedspline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            stepline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            stackedstepline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            fullstackedstepline: {
                                point: {
                                    visible: wParams.showPointsInLines == null ? true : wParams.showPointsInLines
                                }
                            },
                            //LL: can be set, but no sense:
                            //scatter: {
                            //    point: {
                            //        visible: (wParams.showPointsInArea == null) ? false : wParams.showPointsInArea
                            //    }
                            //},
                            area: {
                                //LL: settings for "area" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            stackedarea: {
                                //LL: settings for "stackedarea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            fullstackedarea: {
                                //LL: settings for "fullstackedarea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            splinearea: {
                                //LL: settings for "splinearea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            stackedsplinearea: {
                                //LL: settings for "stackedsplinearea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            fullstackedsplinearea: {
                                //LL: settings for "fullstackedsplinearea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            steparea: {
                                //LL: settings for "steparea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            stackedsteparea: {
                                //LL: settings for "stackedsteparea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            fullstackedsteparea: {
                                //LL: settings for "fullstackedsteparea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            },
                            rangearea: {
                                //LL: settings for " rangearea" charts
                                point: {
                                    visible: wParams.showPointsInArea == null ? false : wParams.showPointsInArea
                                }
                            }
                        }, // FIN commonSeriesSettings

                        //LL: Taras: use redrawOnResize: false, we handle resizing of charts with platform generated 'resize' event
                        redrawOnResize: false,
                        dataSource: dataSource,
                        series: series,
                        rotated: wParams.rotatedXY,
                        barGroupPadding: barGroupPadding,

                        //LL: scrollBar for DevExpr ver 18.2 ===============
                        // The scroll bar allows a user to pan the chart.
                        //   To use it, you need to enable zooming and panning in your chart.
                        // By default, the scroll bar is hidden.
                        // To make it visible, set the visible field of the scrollBar object to true.
                        // Using other fields of this object you can adjust the scroll bar appearance settings, including color, width and opacity
                        //
                        //    color - default 'gray'
                        //    offset - Specifies the spacing between the scroll bar and the chart's plot in pixels   def=5
                        //    opacity - Specifies the opacity of the scroll bar
                        //    position - Specifies the position of the scroll bar in the chart.   def = 'top'
                        //        'bottom' | 'left' | 'right' | 'top'
                        //        Depending on whether the chart is rotated or not, this option accepts different values.
                        //        In a non-rotated chart, you can assign either 'top' or 'bottom' to this option.
                        //        In a rotated chart, this option accepts either 'left' or 'right'
                        //    visible - Specifies whether the scroll bar is visible or not.    def = false
                        //        NOTE: Making the scroll bar visible can be useful only if panning is enabled in your chart.
                        //    width - Specifies the width of the scroll bar in pixels.    def = 10
                        scrollBar: {
                            visible: wParams.scrollBar.show,
                            position: wParams.rotatedXY
                                ? wParams.scrollBar.position === 'top'
                                    ? 'right'
                                    : 'left'
                                : wParams.scrollBar.position
                        },

                        //LL: zoomAndPan for DevExpr ver 18.2, needed for scrollBar  =========
                        //   You can enable zooming and panning for the argument and value axes independently.
                        //   Set the argumentAxis and valueAxis options to enable zooming, panning, or both for a specific axis.
                        //         'both' | 'none' | 'pan' | 'zoom',   def = 'none'
                        //
                        //   Users can use the mouse and touch gestures to zoom and pan
                        //       'allowMouseWheel' = true, 'allowTouchGestures' = true
                        //   There are also   'dragToZoom', 'dragBoxStyle', 'panKey'
                        zoomAndPan: {
                            argumentAxis: get_zoomAndPan(
                                wParams.scrollAndZoom.zoom_Arguments,
                                wParams.scrollAndZoom.scroll_Arguments
                            ),
                            valueAxis: get_zoomAndPan(
                                wParams.scrollAndZoom.zoom_Values,
                                wParams.scrollAndZoom.scroll_Values
                            )
                        },

                        //LL: try Legend hover   DON'T REM
                        //onDrawn: function (e) {  // e: .component - The widget instance, .element - The widget's container.
                        //    // let clickedPoint = e.target;
                        //
                        //    let svg = e.element.find("svg");
                        //    //console.log("svg = " + svg);
                        //    if (svg != null && svg.length > 0) {
                        //        let dxcLegend = svg.find(".dxc-legend");  // <g>
                        //        //console.log("dxcLegend = " + dxcLegend);
                        //
                        //        if (dxcLegend != null && dxcLegend.length > 0) {
                        //            let dxcLegendG = dxcLegend.find("g");  // the only child
                        //            if (dxcLegendG != null && dxcLegendG.length > 0) {
                        //                let legendAll = dxcLegendG[0];
                        //                //console.log("legendAll childElementCount = " + legendAll.childElementCount);
                        //                //   legendAll childElementCount = 16
                        //
                        //                let rects = dxcLegendG.find("rect");
                        //                let texts = dxcLegendG.find("text");
                        //                //console.log("rects.length = " + rects.length); // rects.length = 8
                        //                //console.log("texts.length = " + texts.length); // texts.length = 8
                        //
                        //                if (texts != null && texts.length > 0) {
                        //                    texts.hover(function(){
                        //                        //console.log("texts.hover 1 " + this); // texts.hover 1 [object SVGTextElement]
                        //                        //$(this).toggleClass('dx-state-hover');
                        //                        // wrong: console.log("texts.hover 1 " + $(this).textContent);
                        //                        console.log("texts.hover 1 " + this.textContent);
                        //
                        //                        let serName = this.textContent;
                        //                        let ser = e.component.getSeriesByName(serName);
                        //                        if (ser != null) {
                        //                            console.log("texts.hover 1 ser = " + ser);
                        //                            if (ser.tag != null) {
                        //                                console.log("texts.hover 1 ser.tag = " + ser.tag);
                        //                            }
                        //                            let hov = ser.isHovered();
                        //                            console.log("texts.hover 1 hov = " + hov);
                        //
                        //                            let serName2 = 'Tue Vestergaard Nielsen (stack=Medium)';
                        //                            let ser2 = e.component.getSeriesByName(serName2);
                        //                            if (ser2 != null) {
                        //                                let hov2 = ser2.isHovered();
                        //                                console.log("texts.hover 1 hov2 = " + hov2);
                        //                                ser2.setHoverView();
                        //                                ser2.setHoverState();
                        //                            }
                        //                        }
                        //                    }, function(){
                        //                        //console.log("texts.hover 2 " + this);
                        //                        //$(this).toggleClass('dx-state-hover');
                        //                        console.log("texts.hover 2 " + this.textContent);
                        //                    });
                        //                    //   or separate:
                        //                    //   mouseenter: addClass
                        //                    //   mouseleave: removeClass
                        //
                        //                    //texts.click(function() {
                        //                    //    alert("texts.click = " + this.textContent);  // VAGTPLAN SUPPORT (stack=Low)
                        //                    //});
                        //                }
                        //
                        //            }
                        //        }
                        //    }
                        //
                        //},

                        //LL: try
                        //  sortingMethod  Type: Boolean | function(a,b)
                        //  a - series point
                        //  Object structure:
                        //    arg: Date|Number|String    The argument of this series point.
                        //    val: Date|Number|String    The value of this series point.
                        //
                        //  Return Value: Number         Indicates whether a comes before b.
                        //
                        //LL: seems it is inside one series, but I need to sort points for an Argument for different series

                        //LL: it sets the order in DataSource, I need the order of series, the order of points for each Argument

                        //dataPrepareSettings: {
                        //    sortingMethod: function (a, b) {
                        //        //return a.val - b.val;
                        //        //LL:  a and b are DataSource extended items, with .tag and other
                        //        //LL: sort by y2:  Arguments are sorted by this: order is D,A,E.C
                        //        return a.y2 - b.y2;
                        //    }
                        //},

                        customizePoint: customizePointFunc,

                        //customizeLabel:  customizeLabelFunc, //LL:  SBS+Stack onlyOneLabelPerStack

                        containerBackgroundColor: wParams.backColor, // Specifies the color of the parent page element, to set equal to container color.  def white

                        palette: wParams.palette,
                        paletteExtensionMode:
                            wParams.paletteExtensionMode == null
                                ? DevExprPaletteManager.paletteExtensionMode_default
                                : wParams.paletteExtensionMode, //LL: DevExpress 18.1.5, default DevExpr is "blend"

                        commonAxisSettings: {
                            stripStyle: StripsWrapperObj.createStripCommonStyle(_theme),
                            constantLineStyle: ConstantLinesWrapperObj.createConstantLineCommonStyle(_theme)
                        },

                        argumentAxis: argumentAxisOption,
                        valueAxis: ValueAxisArr.length > 0 ? ValueAxisArr : mainValueAxisOption,

                        tooltip: TooltipWrapper.createTooltip_forXY(
                            wParams,
                            chartWidgetObj,
                            ArgumentAndPointLabels,
                            ArgumentAndPointLabels_Groups,
                            arrArgumentAndPointLabels,
                            arrArgumentAndPointLabels_Groups,
                            argType,
                            argTimePart,
                            yTimePart,
                            aTimeParts,
                            _theme
                        ),

                        //   A handler for the incidentOccurred event. Executed when an error or warning appears in the widget.
                        //
                        // Information about the event. Object structure:
                        //    component: Object                  The widget's instance.
                        //    element: Element (jQuery or HTML)  The widget's container. It is an HTML Element or a jQuery Element when you use jQuery.
                        //    model: Object                      The model data. Available only if you use Knockout.
                        //    target: any                        Information on the occurred incident.  See below
                        //
                        // When an error or warning appears, the widget notifies you by passing a message to the browser console.
                        // This message contains the ID of the incident, a brief description, and a link to the Errors and
                        // Warnings section where further information about this incident can be found.
                        // However, you can handle errors and warnings in the way that you require.
                        // To do this, implement a callback function performing the required actions and assign it to the onIncidentOccurred option.
                        // Within this function, you can use information about the incident that occurred.
                        // This information can be accessed from the _target_ field of the object passed to the callback function as a parameter.
                        // This information includes the following.
                        //    id
                        //  Contains the ID of the incident. The full list of IDs can be found in the Errors and Warnings section.
                        //    type
                        //  Contains the type of the incident. This field equals "error" for errors or "warning" for warnings.
                        //    args
                        //  Contains the argument of the incident's message. The content of this field varies greatly, depending on the incident. For example, it may contain the name of the data source field that was not specified correctly, or the name of the option that was not set properly.
                        //    text
                        //  Contains the text passed to the browser console. This text includes the content of the args field, if there are any.
                        //    widget
                        //  Contains the name of the widget that produced the error or warning.
                        //    version
                        //  Contains the currently used version of the DevExtreme library.

                        //LL: note:  just defining of this function supressed console warnings !!!
                        //onIncidentOccurred: function (info) {
                        //},
                        //LL:  try:   and see below actual assignment, null here is not good
                        //onIncidentOccurred: _theme[themeFields.DevExpress_messages_processing_method] === 'native' ? null :
                        //    function (e) {
                        //    //console.log("onIncidentOccurred " + e);
                        //    //  component, element, target
                        //    let target = e.target;
                        //    if (target != null) {
                        //        //'warning' | 'success' | 'fail'
                        //        let notifyType = 'warning';
                        //        let waitAction = true;
                        //        if (target.type === "warning") {
                        //            notifyType = 'warning';
                        //            waitAction = false;
                        //        }
                        //        if (target.type === "error") {
                        //            notifyType = 'fail'; //'error';
                        //            waitAction = true;
                        //        }
                        //
                        //        // https://www.telerik.com/blogs/how-to-style-console-log-contents-in-chrome-devtools
                        //        // some console methods like console.warn() and console.error()
                        //        // log contents with certain color differences to draw attention
                        //        // to important messages for the user.
                        //        if (target.type === "warning") {
                        //            let msg = '[Warning] Chart: DevExpress Warning ' + target.id + ' - ' + target.text;
                        //            console.log('%c' + msg, "color:green");
                        //            console.warn(msg);
                        //            console.error(msg);
                        //        }
                        //
                        //        NotificationCallWrapper.notify(notifyType,
                        //            'Chart underlying tool (DevExpress) message: <br>' +
                        //            'Message id = ' + target.id + '<br>' +
                        //            target.text,
                        //            waitAction);
                        //    }
                        //},

                        //LL: 23.06.25 try
                        onArgumentAxisClick: function (e: any) {
                            // A function that is executed when a label on the argument axis is clicked or tapped.
                            // e.argument	Date | Number | String	The clicked label's value.
                            // e.component	Chart	The widget's instance.
                            //console.log('onArgumentAxisClick ' + e.argument); // OK

                            let dataSourceID;
                            let argAxis = wParams.argumentAxis;

                            config.onArgumentAxisClick(e.argument);
                        },

                        pointSelectionMode: getPointSelectionMode(),

                        onPointClick: function (e: any) {
                            // e: .component, .element, .jQueryEvent, .target
                            let clickedPoint = e.target;
                            config.onPointClick(clickedPoint);

                            if (wParams.selectPointOnClick) {
                                // fullState
                                //  Provides information about the state of the point object.
                                //    Type: number
                                //  Each point within a chart can be in several states. These states are represented by the numbers that are enumerated in the list below:
                                //      0 The point is not hovered and not selected (normal state);
                                //      1 The point is hovered;
                                //      2 The point is selected;
                                //      3 The point is hovered and selected.
                                //  You can also use the isHovered() and isSelected() point methods to check whether a point is hovered or selected.
                                //clickedPoint.fullState & 2 ? clickedPoint.clearSelection() : clickedPoint.select();
                                clickedPoint.isSelected() ? clickedPoint.clearSelection() : clickedPoint.select();
                            }

                            //LL: NOTE: A click on a series point causes the seriesClick event to fire after the pointClick event.
                            //     To prevent this behavior, assign true to the jQueryEvent.cancel field
                            //     of the object passed to the pointClick event handler as the argument.
                            if (wParams.pointClickCausesSeriesClick === false) {
                                e.event.stopPropagation();
                            }
                        },

                        onPointSelectionChanged: function (e) {
                            let selectedPoint = e.target;

                            //LL: 22.05.19: bug when more than 1 DataSource Portions ======================
                            // When there are several DataSource Portions, one of them can define C2F-argument, but another does not.
                            // Also Arg can be different
                            // Also theoretically there can be different dataSourceID (so store it, but not used by EU)
                            //
                            // So, create not arrays args, args2, args3,
                            //     but array of actual selections [ { attribute, selectedVals, tag_ser, dataSourceID(?) } ]
                            // ==================================
                            let selections = []; //LL: { attribute, selectedVals, tag_ser, dataSourceID(?) }
                            let dataSourceID;

                            if (selectedPoint != null && selectedPoint.series != null) {
                                let tag = selectedPoint.series.tag;
                                if (tag != null && tag.counters != null) {
                                    dataSourceID = tag.counters.dataSourceID;
                                }
                            }

                            //  component: Object       The widget instance.
                            //  element: Object     The widget's container.

                            //let args = [];
                            //let args2;  //LL: X2 - "stack" value (vice versa)
                            //let args3;  //LL: X3 - "group" value (vice versa)

                            let chart = e.component;
                            $.each(chart.getAllSeries(), function (_, aSer) {
                                let dataSourceID_ser;
                                let tag_ser: any = aSer.tag;
                                if (tag_ser != null && tag_ser.counters != null) {
                                    dataSourceID_ser = tag_ser.counters.dataSourceID;
                                }

                                //   either groupOnly or stacked+group or none
                                let argGroupOnly = tag_ser.groupOnly;
                                let groupOnlyIsX2 = tag_ser.groupOnlyIsX2;
                                let arg2 = tag_ser.stack; // vice versa
                                let arg3 = tag_ser.group; // vice versa
                                let hasSelPoints = false;

                                let hasC2F =
                                    (tag_ser.counters.C2FCount != null && tag_ser.counters.C2FCount > 0) ||
                                    (tag_ser.counters.C2FCount_group != null && tag_ser.counters.C2FCount_group > 0);

                                let APL = tag_ser.apl;

                                //LL: x_ref is entity main type, x_init is "dotted" attribute
                                let arg_attribute = tag_ser.x_init;
                                let field_intervals = 'x_intervals';
                                let field_clickToFilterAttribute = 'x_clickToFilterAttribute';

                                let arg_attribute2;
                                let field_intervals2;
                                let field_clickToFilterAttribute2;
                                let arg_syntaxTree2;
                                let arg_rettype2;
                                //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true:
                                let roleC2Fs: any[]; //LL: arr[{C2F_label,C2F_init,C2F_syntaxTree,etc}]

                                if (hasC2F) {
                                    //arg_attribute = tag_ser.C2F_init;
                                    //field_intervals = 'C2F_intervals';
                                    //field_clickToFilterAttribute = 'C2F_clickToFilterAttribute';
                                    //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true:
                                    if (C2F_Multi !== true) {
                                        arg_attribute2 = tag_ser.C2F_init;
                                        field_intervals2 = 'C2F_intervals';
                                        field_clickToFilterAttribute2 = 'C2F_clickToFilterAttribute';
                                        arg_syntaxTree2 = tag_ser.C2F_syntaxTree;
                                        arg_rettype2 = tag_ser.C2F_rettype;
                                    }
                                    //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true
                                    else {
                                        roleC2Fs = tag_ser.roleC2Fs; //LL: arr[{C2F_label,C2F_init,C2F_syntaxTree,etc}]
                                    }
                                }

                                if (dataSourceID != null && dataSourceID === dataSourceID_ser) {
                                    $.each(aSer.getAllPoints(), function (_, point: any) {
                                        if (point.isSelected() === true) {
                                            hasSelPoints = true;

                                            let curArg = point.argument;
                                            //LL: C2F: try to include both
                                            let curArg2;
                                            if (hasC2F) {
                                                //LL: C2F: try to include both
                                                if (C2F_Multi !== true) {
                                                    if (APL != null && APL[curArg] != null) {
                                                        curArg2 = APL[curArg].C2F;
                                                    }
                                                }
                                            }

                                            addToSelections(
                                                selections,
                                                arg_attribute,
                                                curArg,
                                                tag_ser,
                                                field_intervals,
                                                field_clickToFilterAttribute,
                                                dataSourceID_ser
                                            );

                                            if (hasC2F) {
                                                if (C2F_Multi !== true) {
                                                    addToSelections(
                                                        selections,
                                                        arg_attribute2,
                                                        curArg2,
                                                        tag_ser,
                                                        field_intervals2,
                                                        field_clickToFilterAttribute2,
                                                        dataSourceID_ser,
                                                        arg_syntaxTree2,
                                                        arg_rettype2
                                                    );
                                                }
                                                //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true
                                                else {
                                                    let curArgs = [];
                                                    if (APL != null && APL[curArg] != null) {
                                                        curArgs = APL[curArg].C2F;
                                                    }
                                                    if (roleC2Fs != null && roleC2Fs.length > 0) {
                                                        for (let ia: number = 0; ia < roleC2Fs.length; ia++) {
                                                            let rc: any = roleC2Fs[ia];
                                                            // isC2F_Multi //LL: if true, field_intervals and field_clickToFilterAttribute are not fields, actual
                                                            addToSelections(
                                                                selections,
                                                                rc.C2F_init,
                                                                curArgs[ia],
                                                                tag_ser,
                                                                rc.C2F_intervals,
                                                                rc.C2F_clickToFilterAttribute,
                                                                dataSourceID_ser,
                                                                rc.C2F_syntaxTree,
                                                                rc.C2F_rettype,
                                                                true
                                                            );
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }

                                //LL: if hasC2F, filtering only by C2F - my decision
                                if (!hasC2F) {
                                    if (hasSelPoints) {
                                        if (arg2 != null) {
                                            addToSelections(
                                                selections,
                                                tag_ser.x2_init,
                                                arg2,
                                                tag_ser,
                                                'x2_intervals',
                                                'x2_clickToFilterAttribute',
                                                dataSourceID_ser
                                            );
                                        }

                                        if (arg3 != null) {
                                            addToSelections(
                                                selections,
                                                tag_ser.x3_init,
                                                arg3,
                                                tag_ser,
                                                'x3_intervals',
                                                'x3_clickToFilterAttribute',
                                                dataSourceID_ser
                                            );
                                        }

                                        if (argGroupOnly != null) {
                                            let attribute_GroupOnly;
                                            let field_intervals23;
                                            let field_clickToFilterAttribute23;

                                            if (groupOnlyIsX2 === true) {
                                                attribute_GroupOnly = tag_ser.x2_init;
                                                field_intervals23 = 'x2_intervals';
                                                field_clickToFilterAttribute23 = 'x2_clickToFilterAttribute';
                                            } else {
                                                attribute_GroupOnly = tag_ser.x3_init;
                                                field_intervals23 = 'x3_intervals';
                                                field_clickToFilterAttribute23 = 'x3_clickToFilterAttribute';
                                            }

                                            addToSelections(
                                                selections,
                                                attribute_GroupOnly,
                                                argGroupOnly,
                                                tag_ser,
                                                field_intervals23,
                                                field_clickToFilterAttribute23,
                                                dataSourceID_ser
                                            );
                                        }
                                    }
                                }
                            });

                            config.onPointSelectionChanged(dataSourceID, selectedPoint, selections, e.element, false);
                        },

                        onPointHoverChanged: function (e) {
                            let selectedPoint = e.target;
                            let isHovered = selectedPoint.isHovered();
                        },

                        onSeriesClick: function (e) {
                            let clickedSeries = e.Series;
                            config.onSeriesClick(clickedSeries);
                        },

                        //LL: groupLL to tag as mergeGroup, and to use it in onSeriesHoverChanged afterwards
                        //LL: recommended by DevExpress:
                        //   my ticket: https://www.devexpress.com/Support/Center/Question/Details/T320154/dxchart-provide-the-capability-to-group-series-in-legend
                        //   referenced: https://www.devexpress.com/Support/Center/Question/Details/T520434/dxchart-how-to-display-stacks-in-a-bar-in-the-same-order-as-legend-items
                        //   from https://codepen.io/anon/pen/bRpQqw?editors=0010
                        seriesSelectionMode: 'multiple', // default = 'single'
                        onSeriesHoverChanged: function (e) {
                            let series = e.component.getAllSeries();

                            //  from https://codepen.io/anon/pen/bRpQqw?editors=0010
                            //let currentSeries = series[series.length - 1 - e.target.index];
                            //if (e.target.isHovered()) {
                            //   currentSeries.select();
                            //}
                            //else {
                            //  currentSeries.clearSelection();
                            //}

                            // e.target - The series whose hover state has been changed.
                            let serTarg = e.target;

                            let hov = serTarg.isHovered();

                            let mergeGroup;
                            if (serTarg.tag != null) {
                                mergeGroup = serTarg.tag.mergeGroup;
                            }
                            if (mergeGroup != null) {
                                for (let i = 0; i < series.length; i++) {
                                    let ser = series[i];
                                    if (
                                        ser.tag != null &&
                                        ser.tag.mergeGroup === mergeGroup &&
                                        ser.tag.mainInGroup !== true
                                    ) {
                                        if (hov) {
                                            ser.select();
                                        } else {
                                            ser.clearSelection();
                                        }
                                    }
                                }
                            }
                        },

                        //onInitialized: function (e) {
                        //    console.log(" ======== onInitialized ===");
                        //},

                        adjustOnZoom: adjustOnZoom, //LL: old zoom with RangeSelector

                        //LL: new ZoomAndPan
                        onZoomEnd: function (e) {
                            //   actionType	'zoom' | 'pan'	Indicates whether the user has zoomed or panned the chart.
                            //   axis	Chart Axis	The zoomed/panned axis.
                            //   previousRange	Object	The visual range when zooming or panning starts.
                            //   range	Object	The visual range when zooming or panning ends.
                            //       visualRange: [50, 70]  or
                            //       visualRange: { startValue: 50, endValue: 70 }
                            //   shift	Number   .....
                            //   zoomFactor	Number	The zoom factor.
                            //console.log('onZoomEnd ' + e.axis.isArgumentAxis);

                            //LL: ONLY REACT ==
                            //LL: for RangeSelector
                            if (e.actionType == null) {
                                e.cancel = true;
                                return;
                            }
                            if (e.actionType === undefined) {
                                e.cancel = true;
                                return;
                            }

                            //LL: is called also when range is changed by dxRangeSelector !

                            //LL: method is "rangeSelector" or "zoomAndScroll"
                            _widgetDescriptor.zoomHandler(
                                'zoomAndScroll',
                                e.range.startValue,
                                e.range.endValue,
                                e.axis.isArgumentAxis
                            ); //LL: actually is in Module.tsx
                        },

                        legend: legend
                    };

                    //LL: common for XY, Pie
                    if (_theme[themeFields.DevExpress_messages_processing_method] !== 'native') {
                        chartOptions.onIncidentOccurred = getOnIncidentOccurredHandler(_theme);
                    }

                    if (wParams.crosshair != null && wParams.crosshair.enabled === true) {
                        chartOptions.crosshair = CrosshairWrapper.createCrosshair_forXY(
                            wParams,
                            chartWidgetObj,
                            _theme
                        );
                    }

                    if (wParams.animation != null && wParams.animation.enabled != null) {
                        chartOptions.animation = {
                            enabled: wParams.animation.enabled
                        };
                        if (wParams.animation.duration != null) {
                            chartOptions.animation.duration = wParams.animation.duration;
                        }
                        if (wParams.animation.maxPointCount != null) {
                            chartOptions.animation.maxPointCountSupported = wParams.animation.maxPointCount;
                        }
                    }

                    //LL: 28.02.19:
                    //LL: not a problem:
                    //  https://js.devexpress.com/Documentation/18_1/Guide/Widgets/PieChart/Adaptive_Layout/
                    //     The layout does not automatically adapt to changes made in the widget's container at runtime.
                    //     Therefore, if you enable a user to resize the container, call the render() method after each resizing
                    //     to render the PieChart in the new size.
                    let adaptiveLayoutObj: any = ChartFunctionsWrapper.getAdaptiveLayoutObj(_theme); //LL: without keepLabels, only size
                    //LL: DevExpress default is 80px for both w and h
                    //LL: 01.03.19: keepLabels for XY is true by default by DevExpr  (for Pie false)

                    //LL: 11.09.19: try  Maybe we can use em, rem, not only px ?  % ?
                    //   seems not work
                    //if (adaptiveLayoutObj == null) adaptiveLayoutObj = {};
                    //adaptiveLayoutObj.height = "30rem";

                    //LL: 11.09.19: see themes/main
                    //   Leo's suggestion with opposite meaning,
                    //    but he also wants the default to be "hide", so default = true remains
                    //   'For XY-charts: hide Point labels when widget becomes smaller than specified size'
                    //   true  //LL: true is default by DevExpress for keep Point Labels, //LL: 11.09.19: so opposite now

                    let adaptiveLayout_keepLabelsXY = false;
                    let adaptiveLayout_keepLabelsXY_field = themeFields.adaptiveLayout_keepLabelsXY;
                    if (_theme[adaptiveLayout_keepLabelsXY_field] != null) {
                        adaptiveLayout_keepLabelsXY = _theme[adaptiveLayout_keepLabelsXY_field];
                    }

                    if (adaptiveLayout_keepLabelsXY != null) {
                        if (adaptiveLayoutObj == null) {
                            adaptiveLayoutObj = {};
                        }
                        adaptiveLayoutObj.keepLabels = !adaptiveLayout_keepLabelsXY; //LL:  see - "not" is here now
                    }

                    if (adaptiveLayoutObj != null) {
                        chartOptions.adaptiveLayout = adaptiveLayoutObj;
                    }

                    if (wParams.synchronizeMultiAxes != null) {
                        chartOptions.synchronizeMultiAxes = wParams.synchronizeMultiAxes;
                    }

                    if (wParams.labelXY.resolveLabelOverlapping != null) {
                        chartOptions.resolveLabelOverlapping = wParams.labelXY.resolveLabelOverlapping;
                    }

                    if (wParams.showChartTitle) {
                        chartOptions.title = {
                            //LL:  "visible" is not param of "title", just set "text" to ""
                            horizontalAlignment: title_horizontalAlignment,
                            verticalAlignment: title_verticalAlignment,
                            //subtitle: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null,
                            //LL: 17.03.25: try
                            //subtitle: {text: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null, font: titleFont},
                            //LL: 25.06.25: try
                            subtitle: {
                                text: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null,
                                font: subTitleFont
                            },
                            //placeholderSize: 60,
                            font: titleFont,
                            text: getChartTitleConditional()
                        };
                    }

                    if (argumentAxis_useLabelFormat) {
                        let fp = ChartAxisWrapper.getLabelFormatAndPrecision('x', wParams, argType, _theme); // return { format: lf, precision: prec, custom: axis_customFormat, currency: currency }
                        if (fp != null) {
                            let formatType = fp.format;
                            if (fp.format != null) {
                                chartOptions.tooltip.argumentFormat = fp.format;
                                chartOptions.commonSeriesSettings.label.argumentFormat = fp.format;
                            }

                            if (formatType != null && typeof formatType !== 'function') {
                                let toObj = false;
                                let currency;
                                if (
                                    !_.isObject(formatType) &&
                                    formatType.indexOf('currency') >= 0 &&
                                    wParams.currency != null
                                ) {
                                    currency = wParams.currency;
                                    if (fp.currency != null) {
                                        currency = fp.currency;
                                    }
                                    toObj = true;
                                }
                                let precision;
                                if (fp.precision != null && !fp.custom && (argType === 'i' || argType === 'r')) {
                                    precision = fp.precision;
                                    toObj = true;
                                }
                                if (toObj) {
                                    chartOptions.tooltip.argumentFormat = {
                                        type: formatType
                                    };
                                    chartOptions.commonSeriesSettings.label.argumentFormat = { type: formatType };
                                }
                                if (currency != null) {
                                    chartOptions.tooltip.argumentFormat.currency = currency;
                                    chartOptions.commonSeriesSettings.label.argumentFormat.currency = currency;
                                }
                                if (precision != null) {
                                    chartOptions.tooltip.argumentFormat.precision = precision;
                                    chartOptions.commonSeriesSettings.label.argumentFormat.precision = precision;
                                }
                            }
                        }
                    }

                    if (valueAxis_useLabelFormat) {
                        let fp2 = ChartAxisWrapper.getLabelFormatAndPrecision('y', wParams, yType, _theme); // return { format: lf, precision: prec, custom: axis_customFormat, currency: currency }
                        if (fp2 != null) {
                            let formatType = fp2.format;
                            if (fp2.format != null) {
                                chartOptions.tooltip.format = fp2.format;
                                chartOptions.commonSeriesSettings.label.format = fp2.format;
                            }

                            if (formatType != null && typeof formatType !== 'function') {
                                let toObj = false;
                                let currency;
                                if (
                                    !_.isObject(formatType) &&
                                    formatType.indexOf('currency') >= 0 &&
                                    wParams.currency != null
                                ) {
                                    currency = wParams.currency;
                                    if (fp2.currency != null) {
                                        currency = fp2.currency;
                                    }
                                    toObj = true;
                                }
                                let precision;
                                if (fp2.precision != null && !fp2.custom && (yType === 'i' || yType === 'r')) {
                                    precision = fp2.precision;
                                    toObj = true;
                                }
                                if (toObj) {
                                    chartOptions.tooltip.format = {
                                        type: formatType
                                    };
                                    chartOptions.commonSeriesSettings.label.format = { type: formatType };
                                }
                                if (currency != null) {
                                    chartOptions.tooltip.format.currency = currency;
                                    chartOptions.commonSeriesSettings.label.format.currency = currency;
                                }
                                if (precision != null) {
                                    chartOptions.tooltip.format.precision = precision;
                                    chartOptions.commonSeriesSettings.label.format.precision = precision;
                                }
                            }
                        }
                    }

                    for (let i = 0; i < chartOptions.series.length; i++) {
                        // or simply "series" ?  same objects
                        let ser = chartOptions.series[i];

                        if (ser.axis != null) {
                            let aDef = aDefs[ser.axis];

                            if (aDef != null && aDef.useLabelFormat === true) {
                                let fp2 = ChartAxisWrapper.getLabelFormatAndPrecision(
                                    'a',
                                    wParams,
                                    aDef.aType,
                                    _theme,
                                    aDef.paa
                                ); // return { format: lf, precision: prec, custom: axis_customFormat, currency: currency }
                                if (fp2 != null) {
                                    let formatType = fp2.format;

                                    if (formatType != null && typeof formatType !== 'function') {
                                        if (ser.label == null) {
                                            ser.label = {};
                                        }

                                        //chartOptions.tooltip.format = fp2.format;
                                        ser.label.format = fp2.format;

                                        let toObj = false;
                                        let currency;

                                        if (
                                            !_.isObject(formatType) &&
                                            formatType.indexOf('currency') >= 0 &&
                                            wParams.currency != null
                                        ) {
                                            currency = wParams.currency;
                                            if (fp2.currency != null) {
                                                currency = fp2.currency;
                                            }
                                            toObj = true;
                                        }
                                        let precision;
                                        if (
                                            fp2.precision != null &&
                                            !fp2.custom &&
                                            (aDef.aType === 'i' || aDef.aType === 'r')
                                        ) {
                                            precision = fp2.precision;
                                            toObj = true;
                                        }

                                        if (toObj) {
                                            //chartOptions.tooltip.format = { type: formatType };
                                            ser.label.format = { type: formatType };
                                        }
                                        if (currency != null) {
                                            //chartOptions.tooltip.format.currency = currency;
                                            ser.label.format.currency = currency;
                                        }
                                        if (precision != null) {
                                            //chartOptions.tooltip.format.precision = precision;
                                            ser.label.format.precision = precision;
                                        }
                                    }
                                } // fp2
                            }
                        }
                    }

                    //LL: when categories.length == 0 (DataSource is empty), error for datetime type
                    if (argumentAxis_useCategories && categories.length > 0) {
                        chartOptions.argumentAxis.categories = categories;
                    } //LL: categories are used when type: 'discrete'

                    if (constantLines_hasAsPercentX || strips_hasAsPercentX) {
                        //LL: axis type is continuous
                        let max;
                        let min;

                        for (let k = 0; k < categories.length; k++) {
                            //LL: parseInt(str), parseFloat(str), Number(str)
                            let num = Number(categories[k]);
                            if (!isNaN(num)) {
                                if (max == null || num > max) {
                                    max = num;
                                }
                                if (min == null || num < min) {
                                    min = num;
                                }
                            }
                        }

                        if (max != null) {
                            if (constantLines_hasAsPercentX) {
                                ConstantLinesWrapperObj.applyAsPercent(chartOptions.argumentAxis.constantLines, max);
                            }
                            if (strips_hasAsPercentX) {
                                StripsWrapperObj.applyAsPercent(chartOptions.argumentAxis.strips, max);
                            }
                        }
                    }

                    if (constantLines_hasAsPercentY || strips_hasAsPercentY) {
                        //LL: valueAxis may be array if Secondary Axis are defined !

                        if (maxY != null) {
                            if (constantLines_hasAsPercentY) {
                                ConstantLinesWrapperObj.applyAsPercent(mainValueAxisOption.constantLines, maxY);
                            }
                            if (strips_hasAsPercentY) {
                                StripsWrapperObj.applyAsPercent(mainValueAxisOption.strips, maxY);
                            }
                        }
                    }

                    //  , maxA, minA
                    if (constantLines_hasAsPercentA || strips_hasAsPercentA) {
                        $.each(ValueAxisArr, function (key, axis) {
                            if (key > 0) {
                                //LL: key=0 for main ValueAxis
                                let axisName = axis.name;
                                if (maxA[axisName] != null) {
                                    let ma = maxA[axisName];
                                    ConstantLinesWrapperObj.applyAsPercent(axis.constantLines, ma);
                                    StripsWrapperObj.applyAsPercent(axis.strips, ma);
                                }
                            }
                        });
                    }

                    if (callback != null) {
                        callback(chartOptions);
                    }
                }
            );
        }

        if (createPie) {
            //LL: dataSourcePortions   Not used here ?
            //LL: stackValues for onlyOneLabelPerStack, but not used here (no stack)
            //LL: only DS, maxYC, minYC are used
            config.getDataSource(
                function (
                    DS,
                    dataTypes,
                    maxY,
                    minY,
                    maxA,
                    minA,
                    maxYC,
                    minYC,
                    dataSourceFields,
                    stackValues,
                    dataSourcePortions,
                    dataOneDim
                ) {
                    let dataSourceLen = DS.length;
                    let showLabelsRes = showLabels(dataSourceLen);

                    //  already set far above:
                    //let oArgumentType = ChartFunctionsWrapper.evalArgumentsType(wParams);  // return { argType: argType, argTimePart: argTimePart  }
                    //argType = oArgumentType.argType;
                    //argTimePart = oArgumentType.argTimePart;
                    let oValueType = ChartFunctionsWrapper.evalValuesType(wParams, dataTypes, glob); // return { yType: yType, yTimePart: yTimePart  }
                    yType = oValueType.yType;
                    yTimePart = oValueType.yTimePart;

                    //LL: return { APL: APL, APLG: APLG, arrAPL: arrAPL, arrAPLG: arrAPLG };
                    let aapl = config.getArgumentAndPointLabels(DS, dataSourcePortions);
                    ArgumentAndPointLabels = aapl.APL;
                    arrArgumentAndPointLabels = aapl.arrAPL;

                    maxValueC = maxYC;
                    minValueC = minYC;

                    //LL: when pie, only 1 in AQM  NO !!!
                    const chartTypes = ChartPropsManager.get_ChartTypes_Multi(wParams.externalFunctions.attrQueryMulti);

                    let ownChartType;

                    if (chartTypes != null) {
                        ownChartType = chartTypes[0];
                    }

                    let PieSeries: any = config.getPieSeries(ArgumentAndPointLabels);

                    //LL: try for WI 56227 "Pie Chart: new feature (multi Series) in DevExpress ver 15.2"
                    //  old PieSeries - {},  new PieSeries - []

                    let PieSeriesIsArray = Array.isArray(PieSeries);

                    //LL: multi Series
                    let seriesTag; // x, x_ref, x_color,  counters (xpCount, xlCount, ...)
                    if (PieSeriesIsArray) {
                        // new
                        seriesTag = PieSeries[0].tag;
                    } else {
                        seriesTag = PieSeries.tag;
                    }

                    let addSeriesNameToLabel = wParams.labelPie.addSeriesName;
                    if (!(PieSeriesIsArray && PieSeries.length > 1)) {
                        addSeriesNameToLabel = false;
                    }

                    // - labelPie:

                    let pieLabelWrapperObj = new PiePointLabel_Wrapper(
                        wParams,
                        seriesTag,
                        ArgumentAndPointLabels,
                        addSeriesNameToLabel,
                        dataTypes,
                        _theme
                    );

                    let getPointLabel = pieLabelWrapperObj.getPointLabel; //(arg)
                    let getArgumentLabel = pieLabelWrapperObj.getArgumentLabel; //(arg)
                    let argLabelOverride = pieLabelWrapperObj.get_argLabelOverride();

                    if (argLabelOverride) {
                        legend.customizeText = pieLabelWrapperObj.legend_customizeText_Override;
                    } else {
                        legend.customizeText = pieLabelWrapperObj.legend_customizeText;
                    }

                    let pointLabelOverride = pieLabelWrapperObj.get_pointLabelOverride();

                    let labelPie: any = pieLabelWrapperObj.createPointLabelOption_Pie(argTimePart, yTimePart);

                    // - FIN labelPie

                    //LL: for mobile: add wParams.tooltips
                    let tooltipPie: any = pieLabelWrapperObj.createTooltipOption_Pie(
                        showLabelsRes,
                        wParams.tooltips,
                        argTimePart,
                        yTimePart
                    );

                    // - set params for "PieSeries" :

                    //LL: multi Series
                    if (PieSeriesIsArray) {
                        for (let k = 0; k < PieSeries.length; k++) {
                            let ser = PieSeries[k];

                            ser.type = wParams.chartType;
                            if (ownChartType != null) {
                                ser.type = ownChartType;
                            }

                            ser.label = labelPie;

                            if (wParams.labelPie.showPieLabelsThreshold !== 0) {
                                ser.maxLabelCount = wParams.labelPie.showPieLabelsThreshold;
                            }
                        }
                    } else {
                        PieSeries.type = wParams.chartType;
                        if (ownChartType != null) {
                            PieSeries.type = ownChartType;
                        }

                        PieSeries.label = labelPie;

                        if (wParams.labelPie.showPieLabelsThreshold !== 0) {
                            PieSeries.maxLabelCount = wParams.labelPie.showPieLabelsThreshold;
                        }
                    }

                    // - FIN set params for "PieSeries"

                    pieChartOptions = {
                        dataSource: DS,
                        series: PieSeries,
                        containerBackgroundColor: wParams.backColor, // Specifies the color of the parent page element, to set equal to container color.  def white
                        palette: wParams.palette,
                        paletteExtensionMode:
                            wParams.paletteExtensionMode == null
                                ? DevExprPaletteManager.paletteExtensionMode_default
                                : wParams.paletteExtensionMode, //LL: DevExpress 18.1.5, default DevExpr is "blend"
                        margin: { top: 4, bottom: 4, left: 4, right: 4 },
                        //LL: below: diameter:   // def undef   0-1
                        customizePoint: customizePointFunc,

                        //LL: set below
                        //adaptiveLayout: { keepLabels: false, height: 500, width: 500 },

                        tooltip: tooltipPie,

                        title: {
                            //LL:  "visible" is not param of "title", just set "text" to ""
                            horizontalAlignment: title_horizontalAlignment,
                            verticalAlignment: title_verticalAlignment,
                            //subtitle: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null,
                            //LL: 17.03.25: try
                            //subtitle: {text: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null, font: titleFont},
                            //LL: 26.06.25: try
                            subtitle: {
                                text: title_subTitle != null && title_subTitle !== '' ? title_subTitle : null,
                                font: subTitleFont
                            },
                            //placeholderSize: 60,
                            font: titleFont,
                            text: getChartTitleConditional()
                        },

                        done: function () {
                            //$('#selectionSpan').html('The chart rendering is complete');
                            //console.log('The chart rendering is complete');
                        },

                        pointSelectionMode: getPointSelectionMode(),

                        onPointClick: function (e) {
                            let clickedPoint = e.target;
                            config.onPointClick(clickedPoint);

                            if (wParams.selectPointOnClick) {
                                clickedPoint.isSelected() ? clickedPoint.clearSelection() : clickedPoint.select();
                            }
                        },

                        onPointSelectionChanged: function (e) {
                            let selectedPoint = e.target;

                            let selections = [];

                            let dataSourceID;
                            if (selectedPoint != null && selectedPoint.series != null) {
                                let tag = selectedPoint.series.tag;
                                if (tag != null && tag.counters != null) {
                                    dataSourceID = tag.counters.dataSourceID;
                                }
                            }

                            let chart = e.component;

                            //  "Pie/Doughnut chart type can be only one" - this is prohibition for multi DataDescr
                            //  but there can be several Ys

                            $.each(chart.getAllSeries(), function (_, aSer) {
                                let dataSourceID_ser;
                                let tag_ser = aSer.tag;
                                if (tag_ser != null && tag_ser.counters != null) {
                                    dataSourceID_ser = tag_ser.counters.dataSourceID;
                                }

                                let hasC2F =
                                    (tag_ser.counters.C2FCount != null && tag_ser.counters.C2FCount > 0) ||
                                    (tag_ser.counters.C2FCount_group != null && tag_ser.counters.C2FCount_group > 0);

                                let APL = tag_ser.apl;

                                //LL: x_ref is entity main type, x_init is "dotted" attribute
                                let arg_attribute = tag_ser.x_init;
                                let field_intervals = 'x_intervals';
                                let field_clickToFilterAttribute = 'x_clickToFilterAttribute';

                                let arg_attribute2;
                                let field_intervals2;
                                let field_clickToFilterAttribute2;
                                let arg_syntaxTree2;
                                let arg_rettype2;
                                //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true:
                                let roleC2Fs: any[]; //LL: arr[{C2F_label,C2F_init,C2F_syntaxTree,etc}]

                                if (hasC2F) {
                                    //arg_attribute = tag_ser.C2F_init;
                                    //field_intervals = 'C2F_intervals';
                                    //field_clickToFilterAttribute = 'C2F_clickToFilterAttribute';

                                    //LL: for Pie
                                    //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true:
                                    if (C2F_Multi !== true) {
                                        arg_attribute2 = tag_ser.C2F_init;
                                        field_intervals2 = 'C2F_intervals';
                                        field_clickToFilterAttribute2 = 'C2F_clickToFilterAttribute';
                                        arg_syntaxTree2 = tag_ser.C2F_syntaxTree;
                                        arg_rettype2 = tag_ser.C2F_rettype;
                                    }
                                    //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true
                                    else {
                                        roleC2Fs = tag_ser.roleC2Fs; //LL: arr[{C2F_label,C2F_init,C2F_syntaxTree,etc}]
                                    }
                                }

                                if (dataSourceID != null && dataSourceID === dataSourceID_ser) {
                                    $.each(aSer.getAllPoints(), function (_, point: any) {
                                        if (point.isSelected() === true) {
                                            let curArg = point.argument;
                                            //LL: for Pie
                                            let curArg2;
                                            if (hasC2F) {
                                                if (C2F_Multi !== true) {
                                                    if (APL != null && APL[curArg] != null) {
                                                        curArg2 = APL[curArg].C2F;
                                                    }
                                                }
                                            }

                                            addToSelections(
                                                selections,
                                                arg_attribute,
                                                curArg,
                                                tag_ser,
                                                field_intervals,
                                                field_clickToFilterAttribute,
                                                dataSourceID_ser
                                            );

                                            //LL: for Pie
                                            if (hasC2F) {
                                                if (C2F_Multi !== true) {
                                                    addToSelections(
                                                        selections,
                                                        arg_attribute2,
                                                        curArg2,
                                                        tag_ser,
                                                        field_intervals2,
                                                        field_clickToFilterAttribute2,
                                                        dataSourceID_ser,
                                                        arg_syntaxTree2,
                                                        arg_rettype2
                                                    );
                                                }
                                                //LL: multi C2F:  Roles: C2F_group, C2F_nogroup  when C2F_Multi = true
                                                else {
                                                    let curArgs = [];

                                                    if (APL != null && APL[curArg] != null) {
                                                        curArgs = APL[curArg].C2F;
                                                    }

                                                    if (roleC2Fs != null && roleC2Fs.length > 0) {
                                                        for (let ia: number = 0; ia < roleC2Fs.length; ia++) {
                                                            let rc: any = roleC2Fs[ia];
                                                            //LL:  if true, field_intervals and field_clickToFilterAttribute are not fields, actual
                                                            addToSelections(
                                                                selections,
                                                                rc.C2F_init,
                                                                curArgs[ia],
                                                                tag_ser,
                                                                rc.C2F_intervals,
                                                                rc.C2F_clickToFilterAttribute,
                                                                dataSourceID_ser,
                                                                rc.C2F_syntaxTree,
                                                                rc.C2F_rettype,
                                                                true
                                                            );
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            });

                            config.onPointSelectionChanged(dataSourceID, selectedPoint, selections, e.element, true);
                        },

                        legend: legend
                    };

                    //LL: common for XY, Pie
                    if (_theme[themeFields.DevExpress_messages_processing_method] !== 'native') {
                        pieChartOptions.onIncidentOccurred = getOnIncidentOccurredHandler(_theme);
                    }

                    if (wParams.diameterPie != null) {
                        pieChartOptions.diameter = wParams.diameterPie;
                    }

                    if (wParams.labelPie.resolveLabelOverlapping != null) {
                        pieChartOptions.resolveLabelOverlapping = wParams.labelPie.resolveLabelOverlapping;
                    }

                    if (wParams.animation != null && wParams.animation.enabled != null) {
                        pieChartOptions.animation = {
                            enabled: wParams.animation.enabled
                        };
                        if (wParams.animation.duration != null) {
                            pieChartOptions.animation.duration = wParams.animation.duration;
                        }
                        if (wParams.animation.maxPointCount != null) {
                            pieChartOptions.animation.maxPointCountSupported = wParams.animation.maxPointCount;
                        }
                    }

                    let adaptiveLayoutObj: any = ChartFunctionsWrapper.getAdaptiveLayoutObj(_theme); //LL: without keepLabels, only size
                    //LL: keepLabels for Pie is false by default by DevExpr.  Let it be always
                    if (adaptiveLayoutObj != null) {
                        pieChartOptions.adaptiveLayout = adaptiveLayoutObj;
                    }
                }
            );

            if (callback != null) {
                callback(pieChartOptions);
            }
        }

        co = { chartOptions: chartOptions, pieChartOptions: pieChartOptions };
        return co;
    } // FIN createChartOptions
}

//LL: common for XY, Pie
function getOnIncidentOccurredHandler(theme: IValuesCollection) {
    const warnConsole = theme[themeFields.DevExpress_messages_warnings_console];
    const warnScreen = theme[themeFields.DevExpress_messages_warnings_screen];
    const errConsole = theme[themeFields.DevExpress_messages_errors_console];
    const errScreen = theme[themeFields.DevExpress_messages_errors_screen];

    return (e: IOnIncidentOccurredParam) => {
        let target = e.target;

        if (target != null) {
            let showNotification = false;
            let notifyType = 'warning'; //'warning' | 'success' | 'fail'
            let waitAction = true;

            if (target.type === 'warning') {
                notifyType = 'warning';
                waitAction = false;
                showNotification = warnScreen;
            }

            if (target.type === 'error') {
                notifyType = 'fail'; //'error';
                waitAction = true;
                showNotification = errScreen;
            }

            //LL: https://www.telerik.com/blogs/how-to-style-console-log-contents-in-chrome-devtools
            // some console methods like console.warn() and console.error()
            // log contents with certain color differences to draw attention
            // to important messages for the user.
            //LL: also see https://stackoverflow.com/questions/7505623/colors-in-javascript-console
            // and https://developer.chrome.com/docs/devtools/console/api/#styling_console_output_with_css

            if (target.type === 'warning' && warnConsole) {
                let msg =
                    '[Warning] Chart (component ' +
                    target.widget +
                    '): DevExpress Warning ' +
                    target.id +
                    ' - ' +
                    target.text;
                console.warn(msg);
            }

            if (target.type === 'error' && errConsole) {
                let msg =
                    '[Error] Chart (component ' +
                    target.widget +
                    '): DevExpress Error ' +
                    target.id +
                    ' - ' +
                    target.text;
                console.error(msg);
            }

            if (showNotification) {
                let errE2002 = '';

                if (target.id === 'E2002') {
                    // Axis type and data type are incompatible
                    let aa = e.component.getArgumentAxis();
                    let va = e.component.getValueAxis(); //LL: main, there is getValueAxis(name)
                    let ao = aa.getOptions();
                    let aaType = ao.type; //aa._options.type;
                    let aaArgType = ao.argumentType; //aa._options.argumentType;
                    let vo = va.getOptions();
                    let vaType = vo.type; //va._options.type;
                    let vaValType = vo.valueType; //va._options.valueType;

                    if (aaType == null) {
                        aaType = 'automatic';
                    }

                    if (aaArgType == null) {
                        //aaArgType = 'automatic'; //'not defined';
                        aaArgType = 'not defined(automatic)';
                    }

                    if (vaType == null) {
                        vaType = 'automatic';
                    }

                    if (vaValType == null) {
                        //vaValType = 'automatic'; //'not defined';
                        vaValType = 'not defined(automatic)';
                    }

                    errE2002 =
                        '<br>' +
                        'Argument Axis: type=' +
                        aaType +
                        ' dataType=' +
                        aaArgType +
                        '<br>' +
                        'Value Axis: type=' +
                        vaType +
                        ' dataType=' +
                        vaValType;
                }

                NotificationCallWrapper.notify(
                    notifyType,
                    'Chart underlying tool (DevExpress) message: <br>' +
                        'Component = ' +
                        target.widget +
                        ' Message id = ' +
                        target.id +
                        '<br>' +
                        target.text +
                        errE2002,
                    waitAction
                );
            }
        }
    };
}
